<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <!-- color="#fffff" -->
    <ActionsNav></ActionsNav>
    <div class="Actions__Content">
      <v-container fluid>
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->
        <!-- :key="this.id"
            :name="this.name" -->

        <div
          class="Tank TankSingle"
          style="height: 250px !important"
          :data-warehouse-id="this.id"
          :data-warehouse-name="this.name"
          :data-warehouse-type="this.type"
          :data-warehouse-type-id="this.typeId"
          ref="chartdiv"
        ></div>
        <div>
          <p
            style="
              width: 97%;
              text-align: right;
              margin-top: -15px;
              color: grey;
            "
            v-if="type !== 'bottled_wine'"
          >
            *Vrednosti su u RSD
          </p>
          <p
            style="
              width: 97%;
              text-align: right;
              margin-top: -15px;
              color: grey;
            "
            v-else
          >
            *Vrednosti su u broju boca
          </p>
        </div>
      </v-container>

      <div class="DataTable">
        <div fluid style="padding-top: 10px; padding-bottom: 10px">
          <!-- <v-form ref="form"> -->
          <v-app id="inspire" class="TabClass">
            <v-tabs fixed-tabs v-model="selectedTab">
              <v-tab
                v-on:click.native="doSomething()"
                style="padding-left: 20px; padding-right: 20px"
                >Stanja</v-tab
              >
              <v-tab
                v-on:click.native="doSomething()"
                style="padding-left: 20px; padding-right: 20px"
                >Kartice</v-tab
              >
              <v-tab
                v-on:click.native="doSomething()"
                style="padding-left: 20px; padding-right: 20px"
                >Dnevnik</v-tab
              >
              <v-tab
                v-on:click.native="doSomething()"
                style="padding-left: 20px; padding-right: 20px"
                >Izvršenja</v-tab
              >
              <v-tab
                v-on:click.native="doSomething()"
                style="padding-left: 20px; padding-right: 20px"
                >Analitika</v-tab
              >
              <v-tab
                v-if="type === 'bottled_wine'"
                v-on:click.native="doSomething()"
                style="padding-left: 20px; padding-right: 20px"
                >Razduženja</v-tab
              >
            </v-tabs>
            <v-layout
              v-if="selectedTab === 0"
              row
              wrap
              style="max-height: 60px !important; padding-top: 0px !important"
            >
              <!-- <v-flex xs9 pa-2>
                  </v-flex> -->
              <v-flex xs2 pa-2>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Pretraga"
                  xs5
                  hide-details
                ></v-text-field
              ></v-flex>
            </v-layout>
            <template v-if="selectedTab === 0">
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                hide-actions
                item-key="id"
                expand
                ref="dTable"
                :pagination.sync="pagination"
                :search="search"
              >
                <!-- expand -->
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        pagination.descending ? 'desc' : 'asc',
                        header.value === pagination.sortBy ? 'active' : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : 'text-xs-right',
                      ]"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr
                    @click="props.expanded = !props.expanded"
                    v-if="type === 'bottled_wine'"
                  >
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        paginationKartica.rowsPerPage *
                          (paginationKartica.page - 1) +
                        items_states
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) +
                        1
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.name }}
                    </td>
                    <!-- <td style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        ">{{ props.item.lots[0].lot }}</td> -->
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.lots[0].bottleVolumeInLitres }} l
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 15px;
                      "
                    >
                      {{ props.item.quantityState }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ currencyFormatDE(props.item.quantityStateInLitres) }}
                      l
                    </td>
                  </tr>
                  <tr @click="props.expanded = !props.expanded" v-else>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.name }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-if="props.item.lots[0].unitOfMeasure.mark !== null"
                    >
                      {{
                        (props.item.lots[0].unitOfMeasure.mark !== "psc"
                          ? currencyFormatDE4(
                              Math.round(props.item.quantityState * 10000) /
                                10000
                            )
                          : props.item.quantityState) +
                        " " +
                        props.item.lots[0].unitOfMeasure.mark.replace(
                          "psc",
                          "kom"
                        )
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-else
                    >
                      {{
                        (props.item.lots[0].unitOfMeasure.mark !== "psc"
                          ? currencyFormatDE4(
                              Math.round(props.item.quantityState * 10000) /
                                10000
                            )
                          : props.item.quantityState) +
                        " " +
                        props.item.lots[0].unitOfMeasure.mark.replace(
                          "psc",
                          "kom"
                        )
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        currencyFormatDE(
                          Math.round(props.item.price * 100) / 100
                        )
                      }}
                      RSD
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        currencyFormatDE(
                          Math.round(props.item.value * 100) / 100
                        )
                      }}
                      RSD
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <template v-if="type !== 'bottled_wine'">
                    <table class="topics">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                        "
                      >
                        <th
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Lot
                        </th>
                        <th
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Količina
                        </th>
                        <th
                          style="
                            width: 12%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Proizvedeno
                        </th>
                        <th
                          style="
                            width: 12%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Važi do
                        </th>
                        <th
                          style="
                            width: 11%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Cena
                        </th>
                        <th
                          style="
                            width: 24%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Vrednost
                        </th>
                      </tr>
                      <tr v-for="(item, index) in props.item.lots" :key="index">
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ item.lot }}
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            (item.unitOfMeasure.mark !== "psc"
                              ? currencyFormatDE4(
                                  Math.round(item.quantityState * 10000) / 10000
                                )
                              : item.quantityState) +
                            " " +
                            item.unitOfMeasure.mark.replace("psc", "kom")
                          }}
                        </td>
                        <td
                          style="
                            width: 12%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ formatDateTime(item.bottlingOrProductionDate) }}
                        </td>
                        <td
                          style="
                            width: 12%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ formatDateTime(item.validTo) }}
                        </td>
                        <td
                          style="
                            width: 11%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ Math.round(item.price * 100) / 100 }} RSD
                        </td>
                        <td
                          style="
                            width: 24%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            currencyFormatDE(Math.round(item.value * 100) / 100)
                          }}
                          RSD
                        </td>
                      </tr>
                    </table>
                  </template>
                  <template v-else>
                    <table class="topics">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                          width: 50%;
                        "
                      >
                        <th
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 27%;
                          "
                        ></th>
                        <th style="width: 33%">Lot</th>
                        <th
                          style="
                            width: 15%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Stanje boca
                        </th>
                        <th style="width: 25%"></th>
                      </tr>
                      <tr v-for="(item, index) in props.item.lots" :key="index">
                        <td
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                            width: 27%;
                          "
                        ></td>
                        <td style="width: 33%">{{ item.lot }}</td>
                        <td
                          style="
                            width: 15%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ formatInt(item.quantityState) }}
                        </td>
                        <td
                          style="
                            width: 25%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            currencyFormatDE(
                              item.quantityState * item.bottleVolumeInLitres
                            )
                          }}
                          l
                        </td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template slot="no-data">
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
                <template slot="footer" v-if="type === 'bottled_wine'">
                  <td></td>
                  <td></td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    Ukupno:
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 15px;
                    "
                    v-if="totalTab0 !== 0"
                  >
                    {{ formatInt(totalTab0) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 15px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="totalBoca !== 0"
                  >
                    {{ currencyFormatDE(totalBoca) }} l
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                </template>
              </v-data-table>
              <template v-if="type !== 'bottled_wine'">
                <v-layout
                  row
                  wrap
                  style="
                    max-height: 60px !important;
                    padding-top: 0px !important;
                  "
                >
                  <v-flex xs9> </v-flex>

                  <v-flex
                    xs3
                    pa-2
                    style="
                      text-align: right;
                      padding-right: 5px !important;
                      padding-left: 5px !important;
                      border-top-style: solid !important;
                      border-top-width: 1px !important;
                      border-top-color: rgba(0, 0, 0, 0.2);
                    "
                  >
                    Ukupna vrednost:
                    {{ currencyFormatDE(Math.round(total * 100) / 100) }} RSD
                  </v-flex>
                </v-layout>
              </template>
            </template>
            <template v-else-if="selectedTab === 1">
              <v-form ref="form">
                <v-layout
                  row
                  wrap
                  style="
                    max-height: 60px !important;
                    padding-top: 0px !important;
                  "
                >
                  <v-flex xs1 pa-2>
                    <v-menu
                      ref="menuOd"
                      v-model="menuOd"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="dateFormattedOd"
                        label="Datum od"
                        readonly
                        @blur="dateOd = parseDate(dateFormattedOd)"
                      ></v-text-field>
                      <v-date-picker
                        v-model="dateOd"
                        no-title
                        @input="menuOd = false"
                        :max="maxDate"
                      ></v-date-picker>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          dateOd = null;
                          $refs.menuOd.save([]);
                        "
                        >Poništi izbor
                      </v-btn>
                    </v-menu>
                  </v-flex>
                  <v-flex xs1 pa-2>
                    <v-menu
                      ref="menuDo"
                      v-model="menuDo"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="dateFormattedDo"
                        label="Datum do"
                        readonly
                        @blur="dateDo = parseDate(dateFormattedDo)"
                      ></v-text-field>
                      <v-date-picker
                        v-model="dateDo"
                        no-title
                        @input="menuDo = false"
                        :max="maxDate"
                      ></v-date-picker>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          dateDo = null;
                          $refs.menuDo.save([]);
                        "
                        >Poništi izbor
                      </v-btn>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 pa-2 v-if="type !== 'bottled_wine'">
                    <v-autocomplete
                      v-model="article_to_select"
                      :items="article_to_items"
                      item-text="name"
                      item-value="id"
                      label="Naziv"
                      persistent-hint
                      return-object
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 pa-2 v-else>
                    <v-autocomplete
                      v-model="article_to_select"
                      :items="article_to_items"
                      :item-text="getFieldTextWine"
                      item-value="id"
                      label="Vino"
                      persistent-hint
                      return-object
                      :rules="[(v) => !!v || 'Obavezan podatak']"
                      required
                    ></v-autocomplete>
                    <!-- v-on:change="changeArticle" -->
                  </v-flex>
                  <!-- 
                    
                    <v-flex xs2 pa-2 v-if="type === 'bottled_wine'">
                    <v-autocomplete
                      v-model="bottle_to_select"
                      :items="bottle_to_items"
                      item-text="name"
                      item-value="id"
                      label="Boca"
                      persistent-hint
                      return-object
                      :rules="[(v) => !!v || 'Obavezan podatak']"
                      required
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2 pa-2 v-else>
                  </v-flex> -->
                  <v-flex xs5 pa-2> </v-flex>
                  <v-flex xs1 style="text-align: right">
                    <v-btn @click="submitKartice" class="AppButtonFilled"
                      >Pretraži</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
              <template v-if="type !== 'bottled_wine'">
                <v-data-table
                  :headers="headers_states"
                  :items="items_states"
                  class="TankTable"
                  item-key="id"
                  ref="dTable"
                  :pagination.sync="paginationKartica"
                  :total-items="ukupnoRedova"
                  :rows-per-page-items="listSize"
                  rows-per-page-text="Redova na stranici"
                  hide-actions
                >
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          paginationKartica.descending ? 'desc' : 'asc',
                          header.value === paginationKartica.sortBy
                            ? 'active'
                            : '',
                          header.align === 'left'
                            ? 'text-xs-left'
                            : 'text-xs-center',
                        ]"
                        @click="changeSortKartica(header.value)"
                      >
                        <!-- @click="changeSortKartica(header.value)" -->

                        <v-icon small v-if="header.sortable !== false"
                          >arrow_upward</v-icon
                        >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>

                  <template slot="items" slot-scope="props">
                    <tr>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{
                          paginationKartica.rowsPerPage *
                            (paginationKartica.page - 1) +
                          items_states
                            .map(function (x) {
                              return x.id;
                            })
                            .indexOf(props.item.id) +
                          1
                        }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ formatDateTime(props.item.date) }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.documentNumber }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.lot }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ formatDateTime(props.item.productionDate) }}
                      </td>

                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ formatDateTime(props.item.validTo) }}
                      </td>
                      <!-- <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.quantity }}
                          {{ props.item.quantityUnitOfMeasure.mark }}
                        </td> -->
                      <td
                        v-if="props.item.input === true"
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{
                          (props.item.unitOfMeasure !== "psc"
                            ? currencyFormatDE4(
                                Math.round(props.item.quantity * 10000) / 10000
                              )
                            : props.item.quantity) +
                          " " +
                          props.item.unitOfMeasure.replace("psc", "kom")
                        }}
                      </td>
                      <td v-else></td>
                      <td v-if="props.item.input === true"></td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                        v-else
                      >
                        {{
                          (props.item.unitOfMeasure !== "psc"
                            ? currencyFormatDE4(
                                Math.round(props.item.quantity * 10000) / 10000
                              )
                            : props.item.quantity) +
                          " " +
                          props.item.unitOfMeasure.replace("psc", "kom")
                        }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{
                          (props.item.unitOfMeasure !== "psc"
                            ? currencyFormatDE4(
                                Math.round(props.item.quantityState * 10000) /
                                  10000
                              )
                            : props.item.quantityState) +
                          " " +
                          props.item.unitOfMeasure.replace("psc", "kom")
                        }}
                      </td>
                      <td style="display: none">{{ props.item.id }}</td>

                      <td class="DataTable__ButtonHolder">
                        <img
                          class="DataTable__Button"
                          title="Pregled dokumenta"
                          src="../assets/icons/zatabele/ico-view.png"
                          alt="ulaz-grozdja"
                          @click="viewItem(props.item, false)"
                        />
                      </td>
                    </tr>
                  </template>
                  <template slot="pageText" slot-scope="item">
                    {{ item.pageStart }} - {{ item.pageStop }} od
                    {{ item.itemsLength }}
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </template>
              <template v-else>
                <v-data-table
                  :headers="headers_states"
                  :items="items_states"
                  class="TankTable"
                  item-key="id"
                  ref="dTable"
                  :pagination.sync="paginationKartica"
                  :total-items="ukupnoRedova"
                  :rows-per-page-items="listSize"
                  rows-per-page-text="Redova na stranici"
                  style="padding-top: 10px"
                  hide-actions
                >
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          paginationKartica.descending ? 'desc' : 'asc',
                          header.value === paginationKartica.sortBy
                            ? 'active'
                            : '',
                          header.align === 'left'
                            ? 'text-xs-left'
                            : 'text-xs-center',
                        ]"
                        @click="changeSortKartica(header.value)"
                      >
                        <v-icon small v-if="header.sortable !== false"
                          >arrow_upward</v-icon
                        >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>

                  <template slot="items" slot-scope="props">
                    <tr>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{
                          paginationKartica.rowsPerPage *
                            (paginationKartica.page - 1) +
                          items_states
                            .map(function (x) {
                              return x.id;
                            })
                            .indexOf(props.item.id) +
                          1
                        }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ formatDateTime(props.item.date) }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.documentNumber }}
                      </td>
                      <!-- <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.tank }}
                        </td> -->
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.lot }}
                      </td>
                      <td
                        v-if="props.item.input === true"
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.receive }}
                      </td>
                      <td
                        v-else
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.give }}
                      </td>
                      <!-- <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.quantity }}
                          {{ props.item.quantityUnitOfMeasure.mark }}
                        </td> -->
                      <td
                        v-if="props.item.input === true"
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.quantity }}
                      </td>
                      <td v-else></td>
                      <td v-if="props.item.input === true"></td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                        v-else
                      >
                        {{ props.item.quantity }}
                      </td>
                      <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.quantityState }}
                      </td>
                      <td style="display: none">{{ props.item.id }}</td>

                      <td class="DataTable__ButtonHolder">
                        <img
                          class="DataTable__Button"
                          title="Pregled dokumenta"
                          src="../assets/icons/zatabele/ico-view.png"
                          alt="ulaz-grozdja"
                          @click="viewItem(props.item, false)"
                        />
                      </td>
                    </tr>
                  </template>
                  <template slot="pageText" slot-scope="item">
                    {{ item.pageStart }} - {{ item.pageStop }} od
                    {{ item.itemsLength }}
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </template>
              <div class="text-xs-center pt-2">
                <v-layout row>
                  <v-flex xs4></v-flex>
                  <v-flex
                    xs2
                    style="
                      text-align: right;
                      padding-right: 10px;
                      padding-top: 23px;
                    "
                  >
                    Redova na stranici:
                  </v-flex>
                  <v-flex xs1 style="max-width: 3%">
                    <v-select
                      v-model="redovaPoStrani"
                      :items="listSize"
                      item-text="text"
                      item-value="value"
                      persistent-hint
                      v-on:change="changeOperation"
                      style="font-size: 14px"
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs2
                    style="padding-top: 23px; padding-left: 10px"
                    v-if="
                      paginationKartica.rowsPerPage * paginationKartica.page <=
                      ukupnoRedova
                    "
                  >
                    {{
                      1 +
                      paginationKartica.rowsPerPage *
                        (paginationKartica.page - 1) +
                      " - " +
                      paginationKartica.rowsPerPage * paginationKartica.page +
                      " od " +
                      ukupnoRedova
                    }}
                  </v-flex>
                  <v-flex
                    xs2
                    style="padding-top: 23px; padding-left: 10px"
                    v-else
                  >
                    {{
                      1 +
                      paginationKartica.rowsPerPage *
                        (paginationKartica.page - 1) +
                      " - " +
                      ukupnoRedova +
                      " od " +
                      ukupnoRedova
                    }}
                  </v-flex>
                  <v-flex xs2 style="padding-top: 10px; text-align: left">
                    <v-pagination
                      v-model="paginationKartica.page"
                      :length="pages"
                      :total-visible="5"
                    ></v-pagination>
                  </v-flex>
                </v-layout>
              </div>
            </template>
            <template v-else-if="selectedTab === 2">
              <v-layout
                row
                wrap
                style="max-height: 60px !important; padding-top: 0px !important"
              >
                <v-flex xs1 pa-2>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormatted"
                      label="Datum od"
                      readonly
                      @blur="date = parseDate(dateFormatted)"
                    ></v-text-field>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="menu = false"
                      :max="maxDate"
                    ></v-date-picker>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        date = null;
                        $refs.menu.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
                <v-flex xs1 pa-2>
                  <v-menu
                    ref="menuKupovine"
                    v-model="menuKupovine"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="dateFormattedKupovine"
                      label="Datum do"
                      readonly
                      @blur="dateKupovine = parseDate(dateFormattedKupovine)"
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateKupovine"
                      no-title
                      @input="menuKupovine = false"
                      :max="maxDate"
                    ></v-date-picker>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        dateKupovine = null;
                        $refs.menuKupovine.save([]);
                      "
                      >Poništi izbor
                    </v-btn>
                  </v-menu>
                </v-flex>
                <v-flex xs9 pa-2>
                  <v-autocomplete
                    ref="element_types"
                    v-model="document_type_to_select"
                    :items="document_type_to_items"
                    :item-text="getFieldTextTypes"
                    item-value="id"
                    label="Dokument"
                    multiple
                    chips
                    deletable-chips
                    hide-no-data
                    clearable
                    v-on:change="showFields"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs1 style="text-align: right">
                  <v-btn @click="submit" class="AppButtonFilled"
                    >Pretraži</v-btn
                  >
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
                style="max-height: 60px !important; padding-top: 0px !important"
              >
                <!-- <v-flex xs9 pa-2>
                  </v-flex> -->
                <v-flex xs3 pa-2>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Pretraga"
                    xs5
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 pa-2> </v-flex>
                <v-flex
                  xs1
                  style="
                    text-align: center;
                    margin-bottom: 0px;
                    padding-left: 30px;
                  "
                >
                  <v-btn @click="stampaj_dnevnik" fab small
                    ><img
                      src="../assets/menuIcons/ico-print.png"
                      title="Štampa dnevnika"
                  /></v-btn>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="headers_states"
                :items="items_states_pom"
                class="TankTable"
                item-key="id"
                expand
                ref="dTable"
                :pagination.sync="paginationKartica"
                :total-items="ukupnoRedova"
                :rows-per-page-items="listSize"
                rows-per-page-text="Redova na stranici"
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <!-- @click="changeSortKartica(header.value)" -->

                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      @click="props.expanded = !props.expanded"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        paginationKartica.rowsPerPage *
                          (paginationKartica.page - 1) +
                        items_states_pom
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) +
                        1
                      }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.number }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.give !== null"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.give.firstName +
                        " " +
                        props.item.give.lastName
                      }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-else
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      -
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.receive !== null"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.receive.firstName +
                        " " +
                        props.item.receive.lastName
                      }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      -
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.company !== null"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.company.name }}
                    </td>
                    <td
                      v-else
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      -
                    </td>
                    <!-- <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.type }}
                      </td> -->
                    <td style="display: none">{{ props.item.id }}</td>

                    <td class="DataTable__ButtonHolder">
                      <img
                        class="DataTable__Button"
                        title="Pregled dokumenta"
                        src="/assets/icons/zatabele/ico-edit2.svg"
                        alt="ulaz-grozdja"
                        @click="viewItem(props.item, true)"
                        v-if="props.item.editable"
                      />
                      <img
                        class="DataTable__Button"
                        title="Pregled dokumenta"
                        src="../assets/icons/zatabele/ico-view.png"
                        alt="ulaz-grozdja"
                        @click="viewItem(props.item, false)"
                        v-else
                      />
                      <img
                        class="DataTable__Button"
                        title="Otkazivanje dokumenta"
                        src="../assets/icons/zatabele/ico-cancel.png"
                        alt="delete-item"
                        @click="cancelItem(props.item)"
                      />
                      <img
                        class="DataTable__Button"
                        title="Štampa dokumenta"
                        src="../assets/icons/zatabele/ico-print.png"
                        alt="delete-item"
                        @click="printItem(props.item)"
                        v-if="
                          props.item.number.substring(0, 3) === 'PRO' ||
                          props.item.number.substring(0, 3) === 'IZD' ||
                          props.item.number.substring(0, 3) === 'MMI'
                        "
                      />
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <template v-if="type !== 'bottled_wine'">
                    <table class="topics">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                        "
                      >
                        <th style="width: 20%">Naziv</th>
                        <th>Lot</th>
                        <th>Proizvedeno</th>
                        <th>Važi do</th>
                        <th>Količina</th>
                      </tr>
                      <tr
                        v-for="(item, index) in props.item
                          .warehouseInputOutputItems"
                        :key="index"
                      >
                        <td style="width: 20%">{{ item.materialName }}</td>
                        <td>{{ item.lot }}</td>
                        <td>
                          {{ formatDateTime(item.bottlingOrProductionDate) }}
                        </td>
                        <td>{{ formatDateTime(item.validTo) }}</td>
                        <td>
                          {{
                            (item.quantityUnitOfMeasure.mark !== "psc"
                              ? currencyFormatDE4(
                                  Math.round(item.quantity * 10000) / 10000
                                )
                              : item.quantity) +
                            " " +
                            item.quantityUnitOfMeasure.mark.replace(
                              "psc",
                              "kom"
                            )
                          }}
                        </td>
                      </tr>
                    </table>
                  </template>
                  <template v-else>
                    <table class="topics">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                        "
                      >
                        <th style="width: 20%">Vino</th>
                        <!-- <th>Flaširano</th> -->
                        <th>Lot</th>
                        <th>Boca</th>
                        <th>Broj boca</th>
                      </tr>
                      <tr
                        v-for="(item, index) in props.item
                          .warehouseInputOutputItems"
                        :key="index"
                      >
                        <td style="width: 30%">
                          {{ item.wineName + " " + item.wineYear }}
                        </td>
                        <!-- <td>{{ formatDateTime(item.bottlingOrProductionDate) }}</td> -->
                        <td>{{ item.lot }}</td>
                        <td>{{ item.bottleVolume }}l</td>
                        <td>{{ item.quantity }}</td>
                      </tr>
                    </table>
                  </template>
                </template>

                <template slot="pageText" slot-scope="item">
                  {{ item.pageStart }} - {{ item.pageStop }} od
                  {{ item.itemsLength }}
                </template>
                <template slot="no-data">
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                <v-layout row>
                  <v-flex xs4></v-flex>
                  <v-flex
                    xs2
                    style="
                      text-align: right;
                      padding-right: 10px;
                      padding-top: 23px;
                    "
                  >
                    Redova na stranici:
                  </v-flex>
                  <v-flex xs1 style="max-width: 3%">
                    <v-select
                      v-model="redovaPoStrani"
                      :items="listSize"
                      item-text="text"
                      item-value="value"
                      persistent-hint
                      v-on:change="changeOperation"
                      style="font-size: 14px"
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs2
                    style="padding-top: 23px; padding-left: 10px"
                    v-if="
                      paginationKartica.rowsPerPage * paginationKartica.page <=
                      ukupnoRedova
                    "
                  >
                    {{
                      1 +
                      paginationKartica.rowsPerPage *
                        (paginationKartica.page - 1) +
                      " - " +
                      paginationKartica.rowsPerPage * paginationKartica.page +
                      " od " +
                      ukupnoRedova
                    }}
                  </v-flex>
                  <v-flex
                    xs2
                    style="padding-top: 23px; padding-left: 10px"
                    v-else
                  >
                    {{
                      1 +
                      paginationKartica.rowsPerPage *
                        (paginationKartica.page - 1) +
                      " - " +
                      ukupnoRedova +
                      " od " +
                      ukupnoRedova
                    }}
                  </v-flex>
                  <v-flex xs2 style="padding-top: 10px; text-align: left">
                    <v-pagination
                      v-model="paginationKartica.page"
                      :length="pages"
                      :total-visible="5"
                    ></v-pagination>
                  </v-flex>
                </v-layout>
              </div>
            </template>

            <template v-else-if="selectedTab === 3">
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="id"
                expand
                ref="dTable"
                :pagination.sync="pagination"
                :items-per-page="1000000"
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        pagination.descending ? 'desc' : 'asc',
                        header.value === pagination.sortBy ? 'active' : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : 'text-xs-center',
                      ]"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      @click="props.expanded = !props.expanded"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.number }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.give !== null"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.give.firstName +
                        " " +
                        props.item.give.lastName
                      }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-else
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      -
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-if="props.item.receive !== null"
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.receive.firstName +
                        " " +
                        props.item.receive.lastName
                      }}
                    </td>
                    <td
                      @click="props.expanded = !props.expanded"
                      v-else
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      -
                    </td>
                    <!-- <td
                        style="
                          text-align: center;
                          padding-left: 5px;
                          padding-right: 5px;
                        "
                      >
                        {{ props.item.type }}
                      </td> -->
                    <td style="display: none">{{ props.item.id }}</td>

                    <td class="DataTable__ButtonHolder">
                      <img
                        class="DataTable__Button"
                        title="Izmena dokumenta"
                        src="../assets/icons/zatabele/ico-edit2.svg"
                        alt="ulaz-grozdja"
                        @click="editItem(props.item, false)"
                      />
                      <img
                        v-if="props.item.number.substring(0, 3) !== 'MMP'"
                        class="DataTable__Button"
                        title="Brisanje dokumenta"
                        src="../assets/icons/zatabele/ico-delete2.svg"
                        alt="ulaz-grozdja"
                        @click="deleteItem(props.item)"
                      />
                      <img
                        class="DataTable__Button"
                        title="Izvršenje dokumenta"
                        src="../assets/icons/zatabele/ico-execute.png"
                        alt="delete-item"
                        @click="executeItem(props.item)"
                      />
                      <img
                        class="DataTable__Button"
                        title="Štampa dokumenta"
                        src="../assets/icons/zatabele/ico-print.png"
                        alt="delete-item"
                        @click="printItem(props.item)"
                        v-if="
                          props.item.number.substring(0, 3) === 'PRO' ||
                          props.item.number.substring(0, 3) === 'IZD' ||
                          props.item.number.substring(0, 3) === 'MMI'
                        "
                      />
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">
                  <template v-if="type !== 'bottled_wine'">
                    <table class="topics">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                        "
                      >
                        <th style="width: 20%">Naziv</th>
                        <th>Lot</th>
                        <th>Proizvedeno</th>
                        <th>Važi do</th>
                        <th>Količina</th>
                      </tr>
                      <tr
                        v-for="(item, index) in props.item
                          .warehouseInputOutputItems"
                        :key="index"
                      >
                        <td style="width: 20%">{{ item.materialName }}</td>
                        <td>{{ item.lot }}</td>
                        <td>
                          {{ formatDateTime(item.bottlingOrProductionDate) }}
                        </td>
                        <td>{{ formatDateTime(item.validTo) }}</td>
                        <td>
                          {{
                            item.quantity +
                            " " +
                            item.quantityUnitOfMeasure.mark.replace(
                              "psc",
                              "kom"
                            )
                          }}
                        </td>
                      </tr>
                    </table>
                  </template>
                  <template v-else>
                    <table class="topics">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                        "
                      >
                        <th style="width: 20%">Vino</th>
                        <!-- <th>Flaširano</th> -->
                        <th>Lot</th>
                        <th>Boca</th>
                        <th>Broj boca</th>
                      </tr>
                      <tr
                        v-for="(item, index) in props.item
                          .warehouseInputOutputItems"
                        :key="index"
                      >
                        <td style="width: 20%">
                          {{ item.wineName + " " + item.wineYear }}
                        </td>
                        <!-- <td>{{ formatDateTime(item.bottlingOrProductionDate) }}</td> -->
                        <td>{{ item.lot }}</td>
                        <td>{{ item.bottleVolume }}l</td>
                        <td>{{ item.quantity }}</td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template slot="no-data">
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </template>
            <template v-else-if="selectedTab === 4">
              <v-container
                style="margin: 0px !important; max-width: 100% !important"
              >
                <v-layout
                  row
                  wrap
                  style="
                    max-height: 60px !important;
                    padding-top: 0px !important;
                    max-height: 1000px !important;
                  "
                >
                  <v-flex xs1 pa-2>
                    <v-menu
                      ref="menuOdAnalitika"
                      v-model="menuOdAnalitika"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="dateFormattedOdAnalitika"
                        label="Datum od"
                        readonly
                        @blur="
                          dateOdAnalitika = parseDate(dateFormattedOdAnalitika)
                        "
                      ></v-text-field>
                      <v-date-picker
                        v-model="dateOdAnalitika"
                        no-title
                        @input="menuOdAnalitika = false"
                        :max="maxDate"
                      ></v-date-picker>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          dateOdAnalitika = null;
                          $refs.menuOdAnalitika.save([]);
                        "
                        >Poništi izbor
                      </v-btn>
                    </v-menu>
                  </v-flex>
                  <v-flex xs1 pa-2>
                    <v-menu
                      ref="menuDoAnalitika"
                      v-model="menuDoAnalitika"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="dateFormattedDoAnalitika"
                        label="Datum do"
                        readonly
                        @blur="
                          dateDoAnalitika = parseDate(dateFormattedDoAnalitika)
                        "
                      ></v-text-field>
                      <v-date-picker
                        v-model="dateDoAnalitika"
                        no-title
                        @input="menuDoAnalitika = false"
                        :max="maxDate"
                      ></v-date-picker>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          dateDoAnalitika = null;
                          $refs.menuDoAnalitika.save([]);
                        "
                        >Poništi izbor
                      </v-btn>
                    </v-menu>
                  </v-flex>

                  <v-flex xs9 pa-2> </v-flex>

                  <v-flex xs1 style="text-align: right">
                    <v-btn @click="submitAnalitika" class="AppButtonFilled"
                      >Pretraži</v-btn
                    >
                  </v-flex>
                </v-layout>

                <v-layout
                  row
                  wrap
                  style="
                    padding-top: 0px !important;
                    max-height: 1000px !important;
                  "
                >
                  <v-flex xs12 pa-2 v-if="type !== 'bottled_wine'">
                    <v-autocomplete
                      v-model="article_to_select_analitika"
                      :items="article_to_items_analitika"
                      item-text="name"
                      item-value="id"
                      label="Naziv"
                      persistent-hint
                      return-object
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 pa-2 v-else>
                    <v-autocomplete
                      v-model="article_to_select_analitika"
                      :items="article_to_items_analitika"
                      :item-text="getFieldTextWine"
                      item-value="id"
                      label="Vino"
                      persistent-hint
                      return-object
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      clearable
                      :menu-props="{
                        auto: true,
                        closeOnContentClick: false,
                      }"
                    ></v-autocomplete>
                    <!-- v-on:change="changeArticle" -->
                  </v-flex>
                </v-layout>

                <v-layout
                  row
                  wrap
                  style="
                    padding-top: 0px !important;
                    max-height: 1000px !important;
                  "
                >
                  <v-flex xs12 pa-2>
                    <v-autocomplete
                      ref="element_types"
                      v-model="document_type_to_select"
                      :items="document_type_to_items"
                      :item-text="getFieldTextTypes"
                      item-value="id"
                      label="Dokument"
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      clearable
                      v-on:change="showFields"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  style="
                    padding-top: 0px !important;
                    max-height: 1000px !important;
                  "
                >
                  <v-flex xs6 pa-2 v-if="showVrstePlacanja">
                    <v-autocomplete
                      ref="element_1"
                      v-model="company_to_select"
                      :items="company_to_items"
                      item-value="id"
                      item-text="name"
                      label="Kupac"
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 pa-2 v-if="showVrstePlacanja">
                    <v-autocomplete
                      ref="elementsarza"
                      v-model="placanja_select"
                      :items="placanja_items"
                      :item-text="getFieldText"
                      item-value="id"
                      label="Vrsta plaćanja"
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 pa-2 v-if="showSvrhaIzdavanja">
                    <v-autocomplete
                      ref="elementsarza"
                      v-model="output_type_to_select"
                      :items="output_type_to_items"
                      item-value="id"
                      item-text="name"
                      label="Svrha izdavanja"
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 pa-2 v-if="showDobavljace">
                    <v-autocomplete
                      ref="element_1"
                      v-model="company_to_select_dobavljaci"
                      :items="company_to_items_dobavljaci"
                      item-value="id"
                      item-text="name"
                      label="Dobavljač"
                      multiple
                      chips
                      deletable-chips
                      hide-no-data
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 pa-2>
                    <template>
                      <v-data-table
                        :headers="headers_states"
                        :items="items_states"
                        class="TankTable"
                        item-key="id"
                        ref="dTable"
                        :pagination.sync="paginationKartica"
                        :total-items="ukupnoRedova"
                        :rows-per-page-items="listSize"
                        rows-per-page-text="Redova na stranici"
                        hide-actions
                      >
                        <template slot="headers" slot-scope="props">
                          <tr>
                            <th
                              style="
                                text-align: center;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                              v-for="header in props.headers"
                              :key="header.text"
                              :class="[
                                'column sortable',
                                paginationKartica.descending ? 'desc' : 'asc',
                                header.value === paginationKartica.sortBy
                                  ? 'active'
                                  : '',
                                header.align === 'left'
                                  ? 'text-xs-left'
                                  : header.align === 'right'
                                  ? 'text-xs-right'
                                  : 'text-xs-center',
                              ]"
                              @click="changeSortKartica(header.value)"
                            >
                              <v-icon small v-if="header.sortable !== false"
                                >arrow_upward</v-icon
                              >
                              {{ header.text }}
                            </th>
                          </tr>
                        </template>

                        <template slot="items" slot-scope="props">
                          <tr>
                            <td
                              style="
                                text-align: center;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                            >
                              {{
                                paginationKartica.rowsPerPage *
                                  (paginationKartica.page - 1) +
                                items_states
                                  .map(function (x) {
                                    return x.id;
                                  })
                                  .indexOf(props.item.id) +
                                1
                              }}
                            </td>

                            <td
                              style="
                                text-align: center;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                            >
                              {{ props.item.article }}
                            </td>

                            <td
                              v-if="props.item.company !== null"
                              style="
                                text-align: center;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                            >
                              {{ props.item.company }}
                            </td>
                            <td v-else></td>
                            <td
                              v-if="props.item.document !== null"
                              style="
                                text-align: center;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                            >
                              {{ prevediDokumenata(props.item.document) }}
                            </td>
                            <td v-else></td>
                            <td
                              v-if="props.item.typeForOperation !== null"
                              style="
                                text-align: center;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                            >
                              {{
                                prevediTipoveDokumenata(
                                  props.item.typeForOperation
                                )
                              }}
                            </td>
                            <td v-else></td>
                            <td
                              style="
                                text-align: center;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                            >
                              {{
                                props.item.quantity +
                                " " +
                                props.item.unitOfMeasure.replace("psc", "kom")
                              }}
                            </td>
                            <td
                              style="
                                text-align: right;
                                padding-left: 5px;
                                padding-right: 5px;
                              "
                            >
                              {{ currencyFormatDE(props.item.value) }} RSD
                            </td>
                            <!-- v-if="props.item.document === 'SELLING'"
                              <td v-else></td> -->
                          </tr>
                        </template>
                        <template slot="no-data">
                          <v-alert
                            slot="no-results"
                            :value="true"
                            color="primary"
                            icon="info"
                            >Nema podataka.</v-alert
                          >
                        </template>
                      </v-data-table>
                      <div class="text-xs-center pt-2">
                        <v-layout row>
                          <v-flex xs4></v-flex>
                          <v-flex
                            xs2
                            style="
                              text-align: right;
                              padding-right: 10px;
                              padding-top: 23px;
                            "
                          >
                            Redova na stranici:
                          </v-flex>
                          <v-flex xs1 style="max-width: 3%">
                            <v-select
                              v-model="redovaPoStrani"
                              :items="listSize"
                              item-text="text"
                              item-value="value"
                              persistent-hint
                              v-on:change="changeOperation"
                              style="font-size: 14px"
                            ></v-select>
                          </v-flex>
                          <v-flex
                            xs2
                            style="padding-top: 23px; padding-left: 10px"
                            v-if="
                              paginationKartica.rowsPerPage *
                                paginationKartica.page <=
                              ukupnoRedova
                            "
                          >
                            {{
                              1 +
                              paginationKartica.rowsPerPage *
                                (paginationKartica.page - 1) +
                              " - " +
                              paginationKartica.rowsPerPage *
                                paginationKartica.page +
                              " od " +
                              ukupnoRedova
                            }}
                          </v-flex>
                          <v-flex
                            xs2
                            style="padding-top: 23px; padding-left: 10px"
                            v-else
                          >
                            {{
                              1 +
                              paginationKartica.rowsPerPage *
                                (paginationKartica.page - 1) +
                              " - " +
                              ukupnoRedova +
                              " od " +
                              ukupnoRedova
                            }}
                          </v-flex>
                          <v-flex
                            xs2
                            style="padding-top: 10px; text-align: left"
                          >
                            <v-pagination
                              v-model="paginationKartica.page"
                              :length="pages"
                              :total-visible="5"
                            ></v-pagination>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
            <template v-else-if="selectedTab === 5">
              <v-app
                id="inspire_razduzenja"
                class="TabClass"
                style="padding-top: 10px !important"
              >
                <v-tabs fixed-tabs v-model="selectedTabRazduzenja">
                  <v-tab
                    v-on:click.native="doSomethingRazduzenja()"
                    style="padding-left: 20px; padding-right: 20px"
                    >CEO MAGACIN</v-tab
                  >
                  <v-tab
                    v-on:click.native="doSomethingRazduzenja()"
                    style="padding-left: 20px; padding-right: 20px"
                    >PO KUPCIMA</v-tab
                  >
                </v-tabs>

                <template v-if="selectedTabRazduzenja === 1">
                  <v-form ref="form1">
                    <v-layout
                      row
                      wrap
                      style="
                        padding-top: 0px !important;
                        max-height: 1000px !important;
                      "
                    >
                      <v-flex xs4 pa-2>
                        <v-autocomplete
                          ref="element1"
                          v-model="razduzenja_company_to_select"
                          :items="company_to_items"
                          item-value="id"
                          item-text="name"
                          :rules="[(v) => !!v || 'Obavezan podatak']"
                          label="Kupac"
                          required
                          persistent-hint
                          return-object
                          v-on:change="changeBuyer"
                          clearable
                        ></v-autocomplete>
                      </v-flex>

                      <!-- <v-flex xs6 pa-2> </v-flex>

                        <v-flex xs2 style="text-align: right">
                          <v-btn
                            @click="submitRazduzenja"
                            class="AppButtonFilled"
                            >Pretraži</v-btn
                          >
                        </v-flex> -->
                    </v-layout>
                  </v-form>
                  <v-data-table
                    :headers="headers_states"
                    :items="items_states"
                    class="TankTable"
                    item-key="id"
                    expand
                    ref="dTable1"
                    :pagination.sync="paginationKartica"
                    :total-items="ukupnoRedova"
                    :rows-per-page-items="listSize"
                    rows-per-page-text="Redova na stranici"
                    hide-actions
                  >
                    <template slot="headers" slot-scope="props">
                      <tr>
                        <th
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="[
                            'column sortable',
                            paginationKartica.descending ? 'desc' : 'asc',
                            header.value === paginationKartica.sortBy
                              ? 'active'
                              : '',
                            header.align === 'left'
                              ? 'text-xs-left'
                              : 'text-xs-center',
                          ]"
                          @click="changeSortKartica(header.value)"
                        >
                          <v-icon small v-if="header.sortable !== false"
                            >arrow_upward</v-icon
                          >
                          {{ header.text }}
                        </th>
                      </tr>
                    </template>

                    <template
                      slot="items"
                      slot-scope="props"
                      v-if="items_states.length !== 0"
                    >
                      <tr>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            paginationKartica.rowsPerPage *
                              (paginationKartica.page - 1) +
                            items_states
                              .map(function (x) {
                                return x.id;
                              })
                              .indexOf(props.item.id) +
                            1
                          }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props.item.dateOfDischarge !== null"
                        >
                          {{ formatDateTime(props.item.dateOfDischarge) }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          {{ currentDateTime() }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props.item.date !== null"
                        >
                          {{ formatDateTime(props.item.date) }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          v-if="props.item.employeePaid !== null"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            props.item.employeePaid.firstName +
                            " " +
                            props.item.employeePaid.lastName
                          }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          v-else
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          -
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.previouseDebt }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.sellingValue }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.sumForPaying }}
                        </td>
                        <!-- <td
                            v-if="props.item.value >= props.item.sumForPaying"
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: #018389;
                            "
                          >
                            <template v-if="props.item.value !== null">
                              {{ props.item.value }}
                            </template>
                            <template v-else> - </template>
                          </td>
                          <td
                            v-else
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: red;
                            "
                          >
                            <template v-if="props.item.value !== null">
                              {{ props.item.value }}
                            </template>
                            <template v-else> - </template>
                          </td> -->
                        <template
                          v-if="props.item.value >= props.item.sumForPaying"
                        >
                          <td
                            v-if="props.item.value !== null"
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: #018389;
                            "
                          >
                            {{ props.item.value }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                            "
                            v-else
                          >
                            -
                          </td>
                        </template>
                        <template v-else>
                          <td
                            v-if="props.item.value !== null"
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: red;
                            "
                          >
                            {{ props.item.value }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                            "
                            v-else
                          >
                            -
                          </td>
                        </template>

                        <td
                          class="DataTable__ButtonHolder"
                          style="
                            padding-left: 5px !important;
                            padding-right: 0px !important;
                          "
                        >
                          <img
                            v-if="props.item.isDeletable || props.item.id !== 0"
                            class="DataTable__Button"
                            title="Izmena dokumenta"
                            src="../assets/icons/zatabele/ico-edit2.svg"
                            alt="ulaz-grozdja"
                            @click="editItemDischarge(props.item)"
                          />
                          <img
                            v-else
                            class="DataTable__Button"
                            title="Izmena dokumenta"
                            src="../assets/icons/zatabele/ico-add.svg"
                            alt="ulaz-grozdja"
                            @click="editItemDischarge(props.item)"
                          />
                          <img
                            v-if="props.item.isDeletable"
                            class="DataTable__Button"
                            title="Brisanje dokumenta"
                            src="../assets/icons/zatabele/ico-delete2.svg"
                            alt="ulaz-grozdja"
                            @click="deleteItemDischarge(props.item)"
                          />
                        </td>
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                      <template>
                        <table class="topics">
                          <tr
                            style="
                              border-bottom: solid;
                              border-width: 1px;
                              border-color: grey;
                            "
                          >
                            <!-- <th>Magacin</th> -->
                            <th>Dokument</th>
                            <th>Datum valute</th>
                            <th>Vrednost</th>
                            <th>Prodavac</th>
                            <th
                              style="
                                padding-left: 5px;
                                padding-right: 5px;
                                width: 8.5%;
                                text-align: center !important;
                              "
                            >
                              Funkcije
                            </th>
                          </tr>
                          <tr
                            v-for="(item, index) in props.item
                              .warehouseInputOutputs"
                            :key="index"
                          >
                            <!-- <td style="width: 20%">{{ item.warehouse.name }}</td> -->
                            <td style="width: 31%">{{ item.number }}</td>
                            <td style="width: 20%">
                              {{ formatDateTime1(item.payingDate) }}
                            </td>
                            <td style="width: 20%">{{ item.description }}</td>
                            <td v-if="props.item.give !== null">
                              {{
                                item.give.firstName + " " + item.give.lastName
                              }}
                            </td>
                            <td style="width: 20%" v-else>-</td>
                            <td
                              class="DataTable__ButtonHolder"
                              style="
                                padding-left: 0px !important;
                                padding-right: 0px !important;
                                text-align: center !important;
                              "
                            >
                              <img
                                class="DataTable__Button"
                                title="Pregled dokumenta"
                                src="../assets/icons/zatabele/ico-view.png"
                                alt="ulaz-grozdja"
                                @click="viewItem(item, false)"
                              />
                            </td>
                          </tr>
                        </table>
                      </template>
                    </template>
                    <template slot="no-data">
                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="primary"
                        icon="info"
                        >Nema podataka.</v-alert
                      >
                    </template>
                  </v-data-table>
                </template>
                <template v-else>
                  <v-data-table
                    :headers="headers_states"
                    :items="items_states"
                    class="TankTable"
                    item-key="id"
                    expand
                    ref="dTable"
                    :pagination.sync="paginationKartica"
                    :total-items="ukupnoRedova"
                    :rows-per-page-items="listSize"
                    rows-per-page-text="Redova na stranici"
                    hide-actions
                  >
                    <template slot="headers" slot-scope="props">
                      <tr>
                        <th
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="[
                            'column sortable',
                            paginationKartica.descending ? 'desc' : 'asc',
                            header.value === paginationKartica.sortBy
                              ? 'active'
                              : '',
                            header.align === 'left'
                              ? 'text-xs-left'
                              : 'text-xs-center',
                          ]"
                          @click="changeSortKartica(header.value)"
                        >
                          <v-icon small v-if="header.sortable !== false"
                            >arrow_upward</v-icon
                          >
                          {{ header.text }}
                        </th>
                      </tr>
                    </template>

                    <template slot="items" slot-scope="props">
                      <tr>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            paginationKartica.rowsPerPage *
                              (paginationKartica.page - 1) +
                            items_states
                              .map(function (x) {
                                return x.id;
                              })
                              .indexOf(props.item.id) +
                            1
                          }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props.item.dateOfDischarge !== null"
                        >
                          {{ formatDateTime(props.item.dateOfDischarge) }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          {{ currentDateTime() }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props.item.date !== null"
                        >
                          {{ formatDateTime(props.item.date) }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          v-if="props.item.employeePaid !== null"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            props.item.employeePaid.firstName +
                            " " +
                            props.item.employeePaid.lastName
                          }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          v-else
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          -
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.previouseDebt }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.sellingValue }}
                        </td>
                        <td
                          @click="props.expanded = !props.expanded"
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props.item.sumForPaying }}
                        </td>
                        <!-- <td
                            v-if="props.item.value >= props.item.sumForPaying"
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: #018389;
                            "
                          >
                            <template v-if="props.item.value !== null">
                              {{ props.item.value }}
                            </template>
                            <template v-else> - </template>
                          </td>
                          <td
                            v-else
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: red;
                            "
                          >
                            <template v-if="props.item.value !== null">
                              {{ props.item.value }}
                            </template>
                            <template v-else> - </template>
                          </td> -->

                        <template
                          v-if="props.item.value >= props.item.sumForPaying"
                        >
                          <td
                            v-if="props.item.value !== null"
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: #018389;
                            "
                          >
                            {{ props.item.value }}
                          </td>
                          <td
                            v-else
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                            "
                          >
                            -
                          </td>
                        </template>
                        <template v-else>
                          <td
                            v-if="props.item.value !== null"
                            @click="props.expanded = !props.expanded"
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                              color: red;
                            "
                          >
                            {{ props.item.value }}
                          </td>
                          <td
                            v-else
                            style="
                              text-align: center;
                              padding-left: 5px;
                              padding-right: 5px;
                            "
                          >
                            -
                          </td>
                        </template>

                        <td
                          class="DataTable__ButtonHolder"
                          style="
                            padding-left: 5px !important;
                            padding-right: 0px !important;
                          "
                        >
                          <img
                            v-if="props.item.isDeletable || props.item.id !== 0"
                            class="DataTable__Button"
                            title="Izmena dokumenta"
                            src="../assets/icons/zatabele/ico-edit2.svg"
                            alt="ulaz-grozdja"
                            @click="editItemDischarge(props.item)"
                          />
                          <img
                            v-else
                            class="DataTable__Button"
                            title="Izmena dokumenta"
                            src="../assets/icons/zatabele/ico-add.svg"
                            alt="ulaz-grozdja"
                            @click="editItemDischarge(props.item)"
                          />
                          <img
                            v-if="props.item.isDeletable"
                            class="DataTable__Button"
                            title="Brisanje dokumenta"
                            src="../assets/icons/zatabele/ico-delete2.svg"
                            alt="ulaz-grozdja"
                            @click="deleteItemDischarge(props.item)"
                          />
                        </td>
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                      <template>
                        <table class="topics">
                          <tr
                            style="
                              border-bottom: solid;
                              border-width: 1px;
                              border-color: grey;
                            "
                          >
                            <!-- <th>Magacin</th> -->
                            <th>Dokument</th>
                            <th>Datum valute</th>
                            <th>Vrednost</th>
                            <th>Prodavac</th>
                            <th
                              style="
                                padding-left: 5px;
                                padding-right: 5px;
                                width: 8.5%;
                                text-align: center !important;
                              "
                            >
                              Funkcije
                            </th>
                          </tr>
                          <tr
                            v-for="(item, index) in props.item
                              .warehouseInputOutputs"
                            :key="index"
                          >
                            <!-- <td style="width: 20%">{{ item.warehouse.name }}</td> -->
                            <td style="width: 31%">{{ item.number }}</td>
                            <td style="width: 20%">
                              {{ formatDateTime1(item.payingDate) }}
                            </td>
                            <td style="width: 20%">{{ item.description }}</td>
                            <td
                              style="width: 20%"
                              v-if="props.item.give !== null"
                            >
                              {{
                                item.give.firstName + " " + item.give.lastName
                              }}
                            </td>
                            <td style="width: 20%" v-else>-</td>
                            <td
                              class="DataTable__ButtonHolder"
                              style="
                                padding-left: 0px !important;
                                padding-right: 0px !important;
                                text-align: center !important;
                              "
                            >
                              <img
                                class="DataTable__Button"
                                title="Pregled dokumenta"
                                src="../assets/icons/zatabele/ico-view.png"
                                alt="ulaz-grozdja"
                                @click="viewItem(item, false)"
                              />
                            </td>
                          </tr>
                        </table>
                      </template>
                    </template>
                    <template slot="no-data">
                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="primary"
                        icon="info"
                        >Nema podataka.</v-alert
                      >
                    </template>
                  </v-data-table>
                </template>
                <div class="text-xs-center pt-2">
                  <v-layout row>
                    <v-flex xs4></v-flex>
                    <v-flex
                      xs2
                      style="
                        text-align: right;
                        padding-right: 10px;
                        padding-top: 23px;
                      "
                    >
                      Redova na stranici:
                    </v-flex>
                    <v-flex xs1 style="max-width: 3%">
                      <v-select
                        v-model="redovaPoStrani"
                        :items="listSize"
                        item-text="text"
                        item-value="value"
                        persistent-hint
                        v-on:change="changeOperation"
                        style="font-size: 14px"
                      ></v-select>
                    </v-flex>
                    <v-flex
                      xs2
                      style="padding-top: 23px; padding-left: 10px"
                      v-if="
                        paginationKartica.rowsPerPage *
                          paginationKartica.page <=
                        ukupnoRedova
                      "
                    >
                      {{
                        1 +
                        paginationKartica.rowsPerPage *
                          (paginationKartica.page - 1) +
                        " - " +
                        paginationKartica.rowsPerPage * paginationKartica.page +
                        " od " +
                        ukupnoRedova
                      }}
                    </v-flex>
                    <v-flex
                      xs2
                      style="padding-top: 23px; padding-left: 10px"
                      v-else
                    >
                      {{
                        1 +
                        paginationKartica.rowsPerPage *
                          (paginationKartica.page - 1) +
                        " - " +
                        ukupnoRedova +
                        " od " +
                        ukupnoRedova
                      }}
                    </v-flex>
                    <v-flex xs2 style="padding-top: 10px; text-align: left">
                      <v-pagination
                        v-model="paginationKartica.page"
                        :length="pages"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </div>
              </v-app>
            </template>
          </v-app>
          <!-- </v-form> -->
        </div>
      </div>
    </div>

    <v-dialog
      v-model="dialogNote"
      scrollable
      content-class="ModalInModalMali"
      persistent
    >
      <div data-v-fae5bece class="v-card">
        <div
          data-v-fae5bece
          class="v-card__title headline lighten-2 v-card__title--primary"
          style="
            font-size: 18px !important;
            padding-left: 30px;
            padding-top: 15px;
            padding-right: 16px;
            padding-bottom: 0px;
          "
        >
          <div style="">Razduženje</div>
          <button
            id="closeModalMagacinBtn"
            @click="closeDischarge"
            class="v-btn v-btn--flat white"
          >
            <v-icon>close</v-icon>
          </button>
        </div>
        <WareHouseDischarge
          @newdata="handleData($event)"
          @close="handleData($event)"
          :item="selectedItem"
          :warehouseID="idPom"
          :company="razduzenja_company_to_select"
        />
      </div>
    </v-dialog>

    <v-dialog v-model="dialogSave" scrollable content-class="ModalInModalMali">
      <v-container>
        <div class="DataTable">
          <v-form
            ref="form_modal_save"
            v-model="validModalSave"
            lazy-validation
          >
            <a class="closeModalInModalBtn" @click.prevent="closeModalSave">
              <v-icon>close</v-icon>
            </a>
            <v-layout row wrap style="padding-top: 0px !important">
              <v-flex xs12>
                <v-subheader style="font-size: 18px"
                  >Da li želite da izvršite dokumente:</v-subheader
                >
              </v-flex>
            </v-layout>
            <v-layout row wrap style="padding-top: 0px !important">
              <v-flex xs6 pa-2>
                <v-checkbox
                  style="margin-top: 0px !important"
                  :label="MMILabel"
                  v-model="valueMMI"
                  :checked="valueMMI"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 pa-2>
                <v-checkbox
                  style="margin-top: 0px !important"
                  :label="MMPLabel"
                  v-model="valueMMP"
                  :checked="valueMMP"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap style="padding-top: 0px !important">
              <v-flex xs12 style="text-align: right; margin-bottom: 0px">
                <v-btn
                  :disabled="!validModalSave"
                  @click="submit_save"
                  class="AppButtonFilled"
                  >Izvrši</v-btn
                >
                <v-btn
                  id="Odustani_dugme"
                  @click="closeModalSave"
                  class="AppButtonOutlined"
                  >odustani</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogSaveOtkazi"
      scrollable
      content-class="ModalInModalMali"
    >
      <v-container>
        <div class="DataTable">
          <v-form
            ref="form_modal_save"
            v-model="validModalSaveOtkazi"
            lazy-validation
          >
            <a
              class="closeModalInModalBtn"
              @click.prevent="closeModalSaveOtkazi"
            >
              <v-icon>close</v-icon>
            </a>
            <v-layout row wrap style="padding-top: 0px !important">
              <v-flex xs12>
                <v-subheader style="font-size: 18px"
                  >Da li želite da otkažete dokumente:</v-subheader
                >
              </v-flex>
            </v-layout>
            <v-layout row wrap style="padding-top: 0px !important">
              <v-flex xs6 pa-2>
                <v-checkbox
                  style="margin-top: 0px !important"
                  :label="MMILabel"
                  v-model="valueMMI"
                  :checked="valueMMI"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 pa-2>
                <v-checkbox
                  style="margin-top: 0px !important"
                  :label="MMPLabel"
                  v-model="valueMMP"
                  :checked="valueMMP"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap style="padding-top: 0px !important">
              <v-flex xs12 style="text-align: right; margin-bottom: 0px">
                <v-btn
                  :disabled="!validModalSaveOtkazi"
                  @click="submit_save_otkazi"
                  class="AppButtonFilled"
                  >Otkaži</v-btn
                >
                <v-btn
                  id="Odustani_dugme"
                  @click="closeModalSaveOtkazi"
                  class="AppButtonOutlined"
                  >odustani</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>
    <!-- /.Actions__Content -->
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import WareHouseDischarge from "./WareHouseDischarge";

am4core.useTheme(am4themes_animated);

import { serverBus } from "../main";
import {
  readJSON,
  currencyFormatDE,
  getDateTime,
  getDateTimeNaslov,
  prevediTipoveIzdavanja,
} from "../helpers/Functions";
import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
import ActionsNav from "./parts/ActionsNavMagacin";

import TokenComponent from "../components/Token";

import html2pdf from "html2pdf.js";

const MountedMixin = {
  mounted() {
    this.$emit("mounted");
  },
};

export default {
  name: "Maka",
  dialog: false,
  components: {
    WareHouseDischarge: (resolve) => {
      setTimeout(() => {
        const component = WareHouseDischarge;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Breadcrumbs,
    TokenComponent,
    ActionsNav,

    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      dialogNote: false,
      id: 0,
      name: "",
      type: "",
      typeId: "",
      dataLok: {
        Enzimi: { Maka: 26250, Kvaka1: 2000 },
        Kvasci: {
          Kvaka: 3500,
          Maka1: 2500,
        },
      },
      selectedTab: 0,
      selectedTabRazduzenja: 0,
      headers_states: [],
      items_states: [],
      items_states_pom: [],
      pagination: {
        sortBy: "name",
        descending: false,
        rowsPerPage: 100000,
      },
      listSize: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "Svi", value: 1000000 },
      ],
      redovaPoStrani: 25,
      paginationKartica: {
        sortBy: "date",
        descending: true,
        rowsPerPage: 25,
        descending: true,
        page: 1,
      },
      ukupnoRedova: 0,
      search: "",
      izabranaStranica: 0,
      article_to_select: null,
      article_to_items: [],
      placanja_select: null,
      placanja_items: [],
      output_type_to_select: null,
      output_type_to_items: [],
      article_to_select_analitika: [],
      article_to_items_analitika: [],
      menu: "",
      date: null,
      dateFormatted: null,
      menuKupovine: "",
      dateKupovine: null,
      dateFormattedKupovine: null,
      menuOd: "",
      dateOd: null,
      dateFormattedOd: null,
      menuDo: "",
      dateDo: null,
      dateFormattedDo: null,

      menuOdAnalitika: "",
      dateOdAnalitika: null,
      dateFormattedOdAnalitika: null,
      menuDoAnalitika: "",
      dateDoAnalitika: null,
      dateFormattedDoAnalitika: null,

      globPage: 0,
      globOffset: 0,
      options: {},
      loading: true,
      totalDesserts: 18,
      company_to_select: null,
      company_to_select_dobavljaci: null,
      razduzenja_company_to_select: undefined,
      company_to_items: [],
      company_to_items_dobavljaci: [],
      document_type_to_items: [],
      document_type_to_select: null,
      labelKomitenti: "",
      showVrstePlacanja: false,
      showDobavljace: false,
      showSvrhaIzdavanja: false,
      selectedItem: [],
      idPom: 0,
      valueMMP: undefined,
      valueMMI: true,
      MMPLabel: "MMP",
      MMILabel: "MMI",
      MMPID: 0,
      MMIID: 0,
      validModalSave: true,
      validModalSaveOtkazi: true,
      dialogSave: false,
      dialogSaveOtkazi: false,
      total: 0,
      totalTab0: 0,
      totalBoca: 0,

      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      json_fields_type: [],
      isLoading: false,
      fullPage: true,
      naziv_fajla: "",
      naslov: "",
      podnaslov: "",
      datumOdFiter: "",
      datumDoFiter: "",
      print_item: [],
      print_item_out: [],
    };
  },
  computed: {
    pages() {
      if (
        this.paginationKartica.rowsPerPage == null ||
        this.ukupnoRedova == null
      )
        return 0;

      return Math.ceil(this.ukupnoRedova / this.paginationKartica.rowsPerPage);
    },
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
    params(nv) {
      return {
        ...this.paginationKartica,
        query: this.search,
      };
    },
  },
  methods: {
    formatInt(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    changeOperation(a) {
      this.paginationKartica.page = 1;

      if (a === 1000000) this.paginationKartica.rowsPerPage = this.ukupnoRedova;
      else this.paginationKartica.rowsPerPage = a;
    },
    closeDischarge(e) {
      this.selectedItem = [];
      this.idPom = 0;

      this.dialogNote = false;
    },
    getPaymentTypes() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/payment_type",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.placanja_items = response.data;
        });
    },
    ucitajGrafik: function () {
      let chart = am4core.create(this.$refs.chartdiv, am4charts.TreeMap);

      chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

      // only one level visible initially
      chart.maxLevels = 1;
      // define data fields
      chart.dataFields.value = "count";
      chart.dataFields.name = "name";
      chart.dataFields.children = "children";
      chart.homeText = this.name;

      // enable navigation
      chart.navigationBar = new am4charts.NavigationBar();

      var level0SeriesTemplate = chart.seriesTemplates.create("0");
      level0SeriesTemplate.strokeWidth = 2;

      var bullet0 = level0SeriesTemplate.bullets.push(
        new am4charts.LabelBullet()
      );
      bullet0.locationX = 0.5;
      bullet0.locationY = 0.5;
      bullet0.label.text = "{name}";
      bullet0.label.fill = am4core.color("#ffffff");

      var columnTemplate = level0SeriesTemplate.columns.template;
      var hoverState = columnTemplate.states.create("hover");

      // darken
      hoverState.adapter.add("fill", function (fill, target) {
        if (fill instanceof am4core.Color) {
          return am4core.color(am4core.colors.brighten(fill.rgb, -0.2));
        }
        return fill;
      });
      // level1 series template
      var level1SeriesTemplate = chart.seriesTemplates.create("1");
      level1SeriesTemplate.columns.template.fillOpacity = 0;

      var bullet1 = level1SeriesTemplate.bullets.push(
        new am4charts.LabelBullet()
      );
      bullet1.locationX = 0.5;
      bullet1.locationY = 0.5;
      bullet1.label.text = "{name}";
      bullet1.label.fill = am4core.color("#ffffff");

      // level2 series template
      var level2SeriesTemplate = chart.seriesTemplates.create("2");
      level2SeriesTemplate.columns.template.fillOpacity = 0;

      var bullet2 = level2SeriesTemplate.bullets.push(
        new am4charts.LabelBullet()
      );
      bullet2.locationX = 0.5;
      bullet2.locationY = 0.5;
      bullet2.label.text = "{name}";
      bullet2.label.fill = am4core.color("#ffffff");

      chart.data = this.processData(this.dataLok);
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    currentDateTime() {
      var currentdate = new Date();
      var datetime =
        currentdate.getDate() +
        "." +
        (currentdate.getMonth() + 1) +
        "." +
        currentdate.getFullYear() +
        ". " +
        currentdate.getHours() +
        ":" +
        currentdate.getMinutes();

      return datetime;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    formatDateTime1(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        return [day, month, year].join(".");
      } else return "";
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getFieldTextWine(item) {
      return `${item.label} ${item.year}`;
    },
    getFieldText(item) {
      return this.prevediTipoveDokumenata(item.name);
    },
    getFieldTextTypes(item) {
      return this.prevediDokumenata(item.name);
    },
    getOutputTypes() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/output_type",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          for (const i in response.data) {
            switch (response.data[i].id) {
              case "GIFT":
                response.data[i].name = `Poklon`;

                break;
              case "TASTING":
                response.data[i].name = `Degustacija`;

                break;
              case "REPRESENTATION":
                response.data[i].name = `Reprezentacija`;

                break;
              case "FAIR":
                response.data[i].name = `Sajam`;

                break;
              default:
                response.data[i].name = `Ostalo`;
            }
          }

          console.log(response.data);
          response.data.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
          );

          this.output_type_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/output_type",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      for (const i in response.data) {
                        // console.log(response.data[i].id);
                        switch (response.data[i].id) {
                          case "GIFT":
                            response.data[i].name = `Poklon`;

                            break;
                          case "TASTING":
                            response.data[i].name = `Degustacija`;

                            break;
                          case "REPRESENTATION":
                            response.data[i].name = `Reprezentacija`;

                            break;
                          case "FAIR":
                            response.data[i].name = `Sajam`;

                            break;
                          default:
                            response.data[i].name = `Ostalo`;
                        }
                      }

                      console.log(response.data);
                      response.data.sort((a, b) =>
                        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                      );

                      this.output_type_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    editItem(item, izvrsen) {
      item.edit = true;
      item.executed = izvrsen;

      if (item.type === "INPUT")
        serverBus.$emit("open_modal", 1, "Prijem", item);
      else if (item.type === "SELLING")
        serverBus.$emit("open_modal", 8, "Prodaja", item);
      else if (item.type === "OUTPUT")
        serverBus.$emit("open_modal", 2, "Izdavanje", item);
      else if (item.type === "WRITE_OFF")
        serverBus.$emit("open_modal", 5, "Otpis", item);
      else if (
        item.type === "CHANGE_WAREHOUSE_OUTPUT" ||
        item.type === "CHANGE_WAREHOUSE_INPUT"
      )
        serverBus.$emit("open_modal", 3, "Međumagacinski prenos", item);
      else if (item.type === "TURN_BACK")
        serverBus.$emit("open_modal", 4, "Povraćaj", item);
      else if (item.type === "LAUNCH")
        serverBus.$emit("open_modal", 7, "Lansiranje", item);
      else if (item.type === "STARTING_STATE")
        serverBus.$emit("open_modal", 10, "Početno stanje", item);
      else if (item.type === "DISCHARGING")
        serverBus.$emit("open_modal", 11, "Razduženje", item);
    },
    handleData: function (e) {
      this.selectedItem = [];
      this.idPom = 0;

      this.dialogNote = false;
      if (this.razduzenja_company_to_select === undefined)
        this.getAllRazduzenja(0);
      else this.getAllRazduzenja(this.razduzenja_company_to_select.id);

      this.selectedItem = [];
      this.idPom = 0;
    },
    editItemDischarge(item) {
      this.idPom = this.id;
      this.selectedItem = item;
      this.dialogNote = true;
    },
    deleteItemDischarge(item) {
      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_payment_flow/" +
            item.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (this.razduzenja_company_to_select === undefined)
            this.getAllRazduzenja(0);
          else this.getAllRazduzenja(this.razduzenja_company_to_select.id);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_payment_flow/" +
                        item.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (this.razduzenja_company_to_select === undefined)
                        this.getAllRazduzenja(0);
                      else
                        this.getAllRazduzenja(
                          this.razduzenja_company_to_select.id
                        );
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    viewItem(item, izmena) {
      item.edit = izmena;
      item.executed = izmena;

      if (item.type === "INPUT")
        serverBus.$emit("open_modal", 1, "Prijem", item);
      else if (item.type === "SELLING")
        serverBus.$emit("open_modal", 8, "Prodaja", item);
      else if (item.type === "OUTPUT")
        serverBus.$emit("open_modal", 2, "Izdavanje", item);
      else if (item.type === "WRITE_OFF")
        serverBus.$emit("open_modal", 5, "Otpis", item);
      else if (
        item.type === "CHANGE_WAREHOUSE_OUTPUT" ||
        item.type === "CHANGE_WAREHOUSE_INPUT"
      )
        serverBus.$emit("open_modal", 3, "Međumagacinski prenos", item);
      else if (item.type === "TURN_BACK")
        serverBus.$emit("open_modal", 4, "Povraćaj", item);
      else if (item.type === "LAUNCH")
        serverBus.$emit("open_modal", 7, "Lansiranje", item);
      else if (item.type === "STARTING_STATE")
        serverBus.$emit("open_modal", 10, "Početno stanje", item);
      else if (item.type === "DISCHARGING")
        serverBus.$emit("open_modal", 11, "Razduženje", item);
    },
    deleteItem(item) {
      let pom_string = "vina";

      if (this.type !== "bottled_wine") pom_string = "materijala";

      let pom_operacija = "NOVA OPERACIJA";

      if (item.number.substring(0, 3) === "IZD") pom_operacija = "izlaz";
      else if (item.number.substring(0, 3) === "PRI") pom_operacija = "prijem";
      else if (item.number.substring(0, 3) === "POS")
        pom_operacija = "početno stanje";
      else if (item.number.substring(0, 3) === "OTS") pom_operacija = "otpis";
      else if (item.number.substring(0, 3) === "PRO") pom_operacija = "prodaju";
      else if (item.number.substring(0, 3) === "MMI") {
        pom_operacija = "međumagacinski prenos";
      } else if (item.number.substring(0, 3) === "MMP") {
        pom_operacija = "međumagacinski prijem";
      } else if (item.number.substring(0, 3) === "POV")
        pom_operacija = "povraćaj";
      else if (item.number.substring(0, 3) === "LAN")
        pom_operacija = "lansiranje";

      confirm(
        "Da li želite da obrišete " +
          pom_operacija +
          " " +
          pom_string +
          " " +
          item.number +
          " u magacin?"
      ) && this.brisanjeDokumenta(item.id, item.changeWarehouseRelatedId);
    },
    executeItem(item) {
      if (item.number.substring(0, 3) === "MMI") {
        this.MMIID = item.id;
        this.MMPID = item.changeWarehouseRelatedId;

        this.MMPLabel = item.changeWarehouseRelatedDocumentNumber;
        this.MMILabel = item.number;

        this.dialogSave = true;
      } else {
        let pom_string = "vina";

        if (this.type !== "bottled_wine") pom_string = "materijala";

        let pom_operacija = "NOVA OPERACIJA";

        if (item.number.substring(0, 3) === "IZD") pom_operacija = "izlaz";
        else if (item.number.substring(0, 3) === "PRI")
          pom_operacija = "prijem";
        else if (item.number.substring(0, 3) === "POS")
          pom_operacija = "početno stanje";
        else if (item.number.substring(0, 3) === "OTS") pom_operacija = "otpis";
        else if (item.number.substring(0, 3) === "PRO")
          pom_operacija = "prodaju";
        else if (item.number.substring(0, 3) === "MMI") {
          pom_operacija = "međumagacinski prenos";
        } else if (item.number.substring(0, 3) === "MMP") {
          pom_operacija = "međumagacinski prijem";
        } else if (item.number.substring(0, 3) === "POV")
          pom_operacija = "povraćaj";
        else if (item.number.substring(0, 3) === "LAN")
          pom_operacija = "lansiranje";

        confirm(
          "Da li želite da izvršite " +
            pom_operacija +
            " " +
            pom_string +
            " " +
            item.number +
            " u magacin?"
        ) && this.prijemDokumenta(item.id);
      }
    },
    cancelItem(item) {
      if (item.number.substring(0, 3) === "MMP") {
        this.MMPID = item.id;
        this.MMIID = item.changeWarehouseRelatedId;

        this.MMPLabel = item.number;
        this.MMILabel = item.changeWarehouseRelatedDocumentNumber;

        this.valueMMP = true;
        this.valueMMI = false;

        this.dialogSaveOtkazi = true;
      } else {
        let pom_string = "vina";

        if (this.type !== "bottled_wine") pom_string = "materijala";

        let pom_operacija = "NOVA OPERACIJA";

        if (item.number.substring(0, 3) === "IZD") pom_operacija = "izlaz";
        else if (item.number.substring(0, 3) === "PRI")
          pom_operacija = "prijem";
        else if (item.number.substring(0, 3) === "POS")
          pom_operacija = "početno stanje";
        else if (item.number.substring(0, 3) === "OTS") pom_operacija = "otpis";
        else if (item.number.substring(0, 3) === "PRO")
          pom_operacija = "prodaju";
        else if (item.number.substring(0, 3) === "MMI") {
          pom_operacija = "međumagacinski prenos";
        } else if (item.number.substring(0, 3) === "MMP") {
          pom_operacija = "međumagacinski prijem";
        } else if (item.number.substring(0, 3) === "POV")
          pom_operacija = "povraćaj";
        else if (item.number.substring(0, 3) === "LAN")
          pom_operacija = "lansiranje";

        confirm(
          "Da li želite da otkažete " +
            pom_operacija +
            " " +
            pom_string +
            " " +
            item.number +
            " u magacin?"
        ) && this.otkazivanjeDokumenta(item.id);
      }
    },
    getMaticniPodaci(item) {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/winery_data", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.getKupacPodaci(item, response.data);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/winery_data",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getKupacPodaci(item, response.data);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllItem(item) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/change_warehouse/" +
            item.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (response.data[0].number.substring(0, 3) === "MMI") {
            this.print_item = response.data[0];
            this.print_item_out = response.data[1];
          } else {
            this.print_item = response.data[1];
            this.print_item_out = response.data[0];
          }

          this.getMaticniPodaciMMI(this.print_item, this.print_item_out);
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/change_warehouse/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data[0].number.substring(0, 3) === "MMI") {
                        this.print_item = response.data[0];
                        this.print_item_out = response.data[1];
                      } else {
                        this.print_item = response.data[1];
                        this.print_item_out = response.data[0];
                      }

                      this.getMaticniPodaciMMI(
                        this.print_item,
                        this.print_item_out
                      );
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getMaticniPodaciIzdatnica(item) {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/winery_data", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          if (
            localStorage.getItem("vinarija") === "fruvin" ||
            localStorage.getItem("vinarija") === "winedb"
          )
            this.stampaj_izdatnicu_fruvin(item, response.data);
          else this.stampaj_izdatnicu(item, response.data);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/winery_data",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (
                        localStorage.getItem("vinarija") === "fruvin" ||
                        localStorage.getItem("vinarija") === "winedb"
                      )
                        this.stampaj_izdatnicu_fruvin(item, response.data);
                      else this.stampaj_izdatnicu(item, response.data);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getMaticniPodaciMMI(item, item_out) {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/winery_data", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          if (
            localStorage.getItem("vinarija") === "fruvin" ||
            localStorage.getItem("vinarija") === "winedb"
          )
            this.stampaj_mmi_fruvin(item, item_out, response.data);
          else this.stampaj_mmi(item, item_out, response.data);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/winery_data",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (
                        localStorage.getItem("vinarija") === "fruvin" ||
                        localStorage.getItem("vinarija") === "winedb"
                      )
                        this.stampaj_mmi_fruvin(item, item_out, response.data);
                      else this.stampaj_mmi(item, item_out, response.data);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getKupacPodaci(item, item_maticni_podaci) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/company/" +
            item.company.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if(localStorage.getItem("vinarija") === "fruvin" || localStorage.getItem("vinarija") === "winedb")
            this.stampajFruvin(item, item_maticni_podaci, response.data);
          else this.stampaj(item, item_maticni_podaci, response.data);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/company/" +
                        item.company.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if(localStorage.getItem("vinarija") === "fruvin" || localStorage.getItem("vinarija") === "winedb")
                        this.stampajFruvin(
                          item,
                          item_maticni_podaci,
                          response.data
                        );
                      else
                        this.stampaj(item, item_maticni_podaci, response.data);
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    printItem(item) {
      this.isLoading = true;

      if (item.number.substring(0, 3) === "PRO") this.getMaticniPodaci(item);
      else if (item.number.substring(0, 3) === "IZD")
        this.getMaticniPodaciIzdatnica(item);
      else if (item.number.substring(0, 3) === "MMI") this.getAllItem(item);
    },
    popuniDanaValuteStampa(date1_loc, date2_loc) {
      const date1 = new Date(date1_loc);
      const date2 = new Date(date2_loc);

      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
    currencyFormatDE(num) {
      return num;
      //   .toFixed(2) // always two decimal digits
      //   .replace(".", ",") // replace decimal point character with ,
      //   .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    currencyFormatDE4(num) {
      return (
        num
          .toFixed(4) // always two decimal digits
          // .replace(",", "") // replace decimal point character with ,
          .replace(".", ",")
      ); // replace decimal point character with ,
      // .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    stampaj(item, object, objectKupac) {
      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.name;
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.city;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "PIB: " + (object.taxNumber !== null ? object.taxNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "MB: " +
          (object.identityNumber !== null ? object.identityNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        var elementToPrint2 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint2.innerHTML = "Račun-Otpremnica br. " + item.number;
        else
          elementToPrint2.innerHTML =
            "Račun-Otpremnica br. " + item.documentNumber;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.left = "45%";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Mesto i datum prometa dobra:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          object.postalCode +
          " " +
          object.city +
          ", " +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1.style.margin = "5px 0px 0px 47%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Mesto i datum izdavanja računa:&nbsp;&nbsp;" +
          object.postalCode +
          " " +
          object.city +
          ", " +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1.style.margin = "5px 0px 0px 47%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        if (item.payingDate !== null) {
          let dana = this.popuniDanaValuteStampa(
            item.date.split("T")[0],
            item.payingDate.split("T")[0]
          );

          elementToPrint1 = document.createElement("p");
          elementToPrint1.innerHTML = "Valuta plaćanja " + dana + " dana";
          elementToPrint1.style.margin = "5px 0px 0px 47%";
          elementToPrint1.style.fontSize = "10px";
          elementToPrint.append(elementToPrint1);
        }

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML = "KUPAC:";
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Firma:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          objectKupac.name;
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Adresa:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          objectKupac.address;
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Grad:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          objectKupac.postalCode +
          " " +
          objectKupac.city;
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "PIB:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
          (objectKupac.taxNumber !== null ? objectKupac.taxNumber : "");
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Matični broj:&nbsp;&nbsp;" +
          (objectKupac.identityNumber !== null
            ? objectKupac.identityNumber
            : "");
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 7; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv usluge");
          //cell
          else if (j === 2) text = document.createTextNode("JM");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("Cena za jedinicu");
          //cell
          else if (j === 5) text = document.createTextNode("Rabat");
          //cell
          else if (j === 6) text = document.createTextNode("Iznos u din."); //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "40%";
          else if (j === 2) th.style.width = "5%";
          else if (j === 3) th.style.width = "10%";
          else if (j === 4) th.style.width = "15%";
          else if (j === 5) th.style.width = "10%";
          else if (j === 6) th.style.width = "15%";

          // if(j === 1)
          //         th.setAttribute('style','text-align :left; padding-left: 5px;');
          //       else
          //         th.setAttribute('style','text-align :center;');

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let ukupno = 0;

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 7; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              if (item.warehouseInputOutputItems[i].bottleVolume !== null)
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].wineName +
                    " - " +
                    item.warehouseInputOutputItems[i].wineYear +
                    ", " +
                    item.warehouseInputOutputItems[i].bottleVolume +
                    "l"
                );
              else
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].materialName
                );
            }
            //cell
            else if (j === 2) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 4)
              cellText = document.createTextNode(
                currencyFormatDE(item.warehouseInputOutputItems[i].price)
              );
            //cell
            else if (j === 5)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].discount === 0
                  ? "-"
                  : currencyFormatDE(
                      item.warehouseInputOutputItems[i].discount
                    ) + "%"
              );
            //cell
            else if (j === 6)
              cellText = document.createTextNode(
                currencyFormatDE(
                  (item.warehouseInputOutputItems[i].quantity *
                    item.warehouseInputOutputItems[i].price *
                    (100 - item.warehouseInputOutputItems[i].discount)) /
                    100
                )
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          ukupno =
            ukupno +
            (item.warehouseInputOutputItems[i].quantity *
              item.warehouseInputOutputItems[i].price *
              (100 - item.warehouseInputOutputItems[i].discount)) /
              100;

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        let rabat = 0;
        if (item.discount !== null) rabat = (ukupno * item.discount) / 100;

        let osnovica = ukupno - rabat;

        let pdv = 0;
        if (item.vat !== null) pdv = (osnovica * item.vat) / 100;

        let svega = osnovica + pdv;

        for (var i = 0; i < 5; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 2; j++) {
            var cell = document.createElement("td");
            var cellText = "";

            if (i === 0) {
              if (j === 0) cellText = document.createTextNode("UKUPNO");
              else cellText = document.createTextNode(currencyFormatDE(ukupno));
            } else if (i === 1) {
              if (j === 0)
                cellText = document.createTextNode(
                  "Rabat " + item.discount + "%"
                );
              else cellText = document.createTextNode(currencyFormatDE(rabat));
            } else if (i === 2) {
              if (j === 0)
                cellText = document.createTextNode("Osnovica u din.");
              else
                cellText = document.createTextNode(currencyFormatDE(osnovica));
            } else if (i === 3) {
              if (j === 0)
                cellText = document.createTextNode("PDV " + item.vat + "%");
              else cellText = document.createTextNode(currencyFormatDE(pdv));
            } else {
              if (j === 0)
                cellText = document.createTextNode("Svega za uplatu");
              else cellText = document.createTextNode(currencyFormatDE(svega));
            }

            if (j === 0) {
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
              cell.style.fontWeight = "bold";
            } else {
              cell.setAttribute(
                "style",
                "text-align :center;padding-right: 8px;"
              );
              if (i === 4) cell.style.fontWeight = "bold";
            }

            cell.appendChild(cellText);
            if (j === 0) cell.style.width = "11%";
            else cell.style.width = "22%";

            row.appendChild(cell);
            if (i !== 4) row.style.background = "#eaece5";
            else row.style.background = "grey";

            switch (i) {
              case 1:
              case 2:
                if (rabat !== 0) tblBody.appendChild(row);
                break;
              case 3:
                if (pdv !== 0) tblBody.appendChild(row);
                break;
              default:
                tblBody.appendChild(row);
            }
          }
        }

        tbl.style.margin = "20px 0px 0px 63%";
        tbl.style.width = "33%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "Tekući račun: " + object.bankName + " " + object.bankAccount;
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 3; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "35%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "20%";
            cellText = document.createTextNode("");
          } else {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        let _this = this;

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampajFruvin(item, object, objectKupac) {
      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrintImg = document.createElement("div");
        elementToPrintImg.style.width = "50%";
        elementToPrintImg.style.float = "left";

        var elementToPrintZaglavlje = document.createElement("div");
        elementToPrintZaglavlje.style.width = "50%";
        elementToPrintZaglavlje.style.margin = "10px 0px 0px 0%";
        elementToPrintZaglavlje.style.float = "right";

        var elementToPrint1 = document.createElement("img");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "0px 0px 0px 0%";
        elementToPrint1.src =
          "../assets/wineries/" +
          localStorage.getItem("vinarija") +
          "/logo.png";
        elementToPrintImg.append(elementToPrint1);

        elementToPrint.append(elementToPrintImg);

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        elementToPrint1.innerHTML = object.name;
        elementToPrint1.style.fontSize = "10px";
        elementToPrint1.style.fontWeight = "bold";

        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Telefon: " + object.phone;
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "PIB: " +
          (object.taxNumber !== null ? object.taxNumber : "") +
          " / " +
          "MB: " +
          (object.identityNumber !== null ? object.identityNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 5px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.email + " / " + "www.fruvin.com";
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint.append(elementToPrintZaglavlje);

        var nizRacun = object.bankAccount.split("|");
        var nizBanka = object.bankName.split("|");

        for (var j = 0; j < nizBanka.length; j++) {
          elementToPrint1 = document.createElement("p");
          elementToPrint1.style.margin = "3px 0px 0px 50%";
          // elementToPrint1.style.margin = "5px 0px 0px 10px";
          elementToPrint1.innerHTML = nizRacun[j] + " " + nizBanka[j];
          elementToPrint1.style.fontWeight = "bold";
          elementToPrint1.style.fontSize = "10px";
          elementToPrint.append(elementToPrint1);
        }

        var elementToPrint22222 = document.createElement("p");
        elementToPrint22222.innerHTML = "&nbsp;&nbsp;";
        elementToPrint.append(elementToPrint22222);

        //format za margin ide "top, right, bottom, left"

        var elementToPrint111 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint111.innerHTML = "Otpremnica br. " + item.number;
        else
          elementToPrint111.innerHTML = "Otpremnica br. " + item.documentNumber;

        //format za margin ide "top, right, bottom, left"

        // elementToPrint2.style.position = "relative";
        // elementToPrint2.style.left = "45%";
        // elementToPrint2.style.top = "15px";
        // elementToPrint2.style.bottom = "15px";

        // elementToPrint1.style.margin = "5px 0px 5px 45%";

        elementToPrint111.style.margin = "5px 0px 5px 45%";
        elementToPrint111.style.fontSize = "20px";

        var elementToPrint22 = document.createElement("div");
        elementToPrint22.append(elementToPrint111);

        // elementToPrint.append(elementToPrint22);

        elementToPrint111 = document.createElement("p");
        elementToPrint111.innerHTML =
          "Mesto i datum izdavanja:&nbsp;&nbsp;" +
          object.city +
          ", " +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint111.style.margin = "5px 0px 5px 45%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint22.append(elementToPrint111);

        if (item.payingDate !== null) {
          let dana = this.popuniDanaValuteStampa(
            item.date.split("T")[0],
            item.payingDate.split("T")[0]
          );

          elementToPrint111 = document.createElement("p");
          elementToPrint111.innerHTML =
            "Datum prometa dobra " +
            this.formatDate1(item.payingDate.split("T")[0]);
          elementToPrint111.style.margin = "5px 0px 0px 45%";
          // elementToPrint1.style.fontSize = "10px";
          elementToPrint22.append(elementToPrint111);
        }

        elementToPrint.append(elementToPrint22);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML = "KUPAC:";
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML = objectKupac.name;
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML = objectKupac.address;
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML = objectKupac.city;
        elementToPrint1.style.margin = "5px 0px 0px 5%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "PIB&nbsp;" +
          (objectKupac.taxNumber !== null ? objectKupac.taxNumber : "");
        elementToPrint1.style.margin = "5px 0px 0px 2.5%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "MB&nbsp;" +
          (objectKupac.identityNumber !== null
            ? objectKupac.identityNumber
            : "");
        elementToPrint1.style.margin = "5px 0px 0px 2.5%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 7; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv usluge");
          //cell
          else if (j === 2) text = document.createTextNode("JM");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("Cena za jedinicu");
          //cell
          else if (j === 5) text = document.createTextNode("Rabat");
          //cell
          else if (j === 6) text = document.createTextNode("Iznos u din."); //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "40%";
          else if (j === 2) th.style.width = "5%";
          else if (j === 3) th.style.width = "10%";
          else if (j === 4) th.style.width = "15%";
          else if (j === 5) th.style.width = "10%";
          else if (j === 6) th.style.width = "15%";

          // if(j === 1)
          //         th.setAttribute('style','text-align :left; padding-left: 5px;');
          //       else
          //         th.setAttribute('style','text-align :center;');

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let ukupno = 0;

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 7; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              if (item.warehouseInputOutputItems[i].bottleVolume !== null)
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].wineName +
                    " - " +
                    item.warehouseInputOutputItems[i].wineYear +
                    ", " +
                    item.warehouseInputOutputItems[i].bottleVolume +
                    "l"
                );
              else
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].materialName
                );
            }
            //cell
            else if (j === 2) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 4)
              cellText = document.createTextNode(
                currencyFormatDE(item.warehouseInputOutputItems[i].price)
              );
            //cell
            else if (j === 5)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].discount === 0
                  ? "-"
                  : currencyFormatDE(
                      item.warehouseInputOutputItems[i].discount
                    ) + "%"
              );
            //cell
            else if (j === 6)
              cellText = document.createTextNode(
                currencyFormatDE(
                  (item.warehouseInputOutputItems[i].quantity *
                    item.warehouseInputOutputItems[i].price *
                    (100 - item.warehouseInputOutputItems[i].discount)) /
                    100
                )
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          ukupno =
            ukupno +
            (item.warehouseInputOutputItems[i].quantity *
              item.warehouseInputOutputItems[i].price *
              (100 - item.warehouseInputOutputItems[i].discount)) /
              100;

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        let rabat = 0;
        if (item.discount !== null) rabat = (ukupno * item.discount) / 100;

        let osnovica = ukupno - rabat;

        let pdv = 0;
        if (item.vat !== null) pdv = (osnovica * item.vat) / 100;

        let svega = osnovica + pdv;

        for (var i = 0; i < 5; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 2; j++) {
            var cell = document.createElement("td");
            var cellText = "";

            if (i === 0) {
              if (j === 0) cellText = document.createTextNode("UKUPNO");
              else cellText = document.createTextNode(currencyFormatDE(ukupno));
            } else if (i === 1) {
              if (j === 0)
                cellText = document.createTextNode(
                  "RABAT " + item.discount + "%"
                );
              else cellText = document.createTextNode(currencyFormatDE(rabat));
            } else if (i === 2) {
              if (j === 0) cellText = document.createTextNode("OSNOVICA");
              else
                cellText = document.createTextNode(currencyFormatDE(osnovica));
            } else if (i === 3) {
              if (j === 0)
                cellText = document.createTextNode(
                  "PDV STOPA " + item.vat + "%"
                );
              else cellText = document.createTextNode(currencyFormatDE(pdv));
            } else {
              if (j === 0) cellText = document.createTextNode("SVEGA");
              else cellText = document.createTextNode(currencyFormatDE(svega));
            }

            if (j === 0) {
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
              cell.style.fontWeight = "bold";
            } else {
              cell.setAttribute(
                "style",
                "text-align :center;padding-right: 8px;"
              );
              if (i === 4) cell.style.fontWeight = "bold";
            }

            cell.appendChild(cellText);
            if (j === 0) cell.style.width = "13%";
            else cell.style.width = "20%";

            row.appendChild(cell);
            if (i !== 4) row.style.background = "#eaece5";
            else row.style.background = "grey";

            switch (i) {
              case 1:
              case 2:
                if (rabat !== 0) tblBody.appendChild(row);
                break;
              case 3:
                if (pdv !== 0) tblBody.appendChild(row);
                break;
              default:
                tblBody.appendChild(row);
            }
          }
        }

        tbl.style.margin = "20px 0px 0px 63%";
        tbl.style.width = "33%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "Prilikom uplate pozovite se na broj " +
          (item.number !== undefined ? item.number : item.documentNumber) +
          " Način plaćanja: Bezgotovinski";
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.description;
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 35px";
        elementToPrint1.innerHTML =
          "Valuta: " + this.formatDate1(item.payingDate.split("T")[0]);
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "15px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "Napomena: " + (item.description === null ? "" : item.description);
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint.append(elementToPrint1);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 5; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "12.5%";
            cellText = document.createTextNode("");
          } else if (j === 2) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          } else if (j === 3) {
            cell.setAttribute("style", "");
            cell.style.width = "12.5%";
            cellText = document.createTextNode("");
          } else if (j === 4) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Otpremnicu izdao");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        let _this = this;

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampaj_izdatnicu(item, object) {
      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.name;
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.city;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "PIB: " + (object.taxNumber !== null ? object.taxNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "MB: " +
          (object.identityNumber !== null ? object.identityNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        var elementToPrint2 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint2.innerHTML = "Izdatnica br. " + item.number;
        else elementToPrint2.innerHTML = "Izdatnica br. " + item.documentNumber;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.left = "45%";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Datum izdavanja :&nbsp;&nbsp;" +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1.style.margin = "5px 0px 0px 47%";
        elementToPrint1.style.fontSize = "10px";
        elementToPrint.append(elementToPrint1);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        tbl.style.width = "98%";

        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 5; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv robe");
          //cell
          else if (j === 2) text = document.createTextNode("JM");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("Svrha izdavanja");
          //cell
          //else if (j === 5) text = document.createTextNode("Iznos u din."); //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "50%";
          else if (j === 2) th.style.width = "10%";
          else if (j === 3) th.style.width = "15%";
          else if (j === 4) th.style.width = "20%";

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 5; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              if (item.warehouseInputOutputItems[i].bottleVolume !== null)
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].wineName +
                    " - " +
                    item.warehouseInputOutputItems[i].wineYear +
                    ", " +
                    item.warehouseInputOutputItems[i].bottleVolume +
                    "l"
                );
              else
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].materialName
                );
            }
            //cell
            else if (j === 2) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 4)
              cellText = document.createTextNode(
                item.typeForOperation !== null
                  ? prevediTipoveIzdavanja(item.typeForOperation)
                  : "-"
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 3; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "35%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "20%";
            cellText = document.createTextNode("");
          } else {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        let _this = this;

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampaj_izdatnicu_fruvin(item, object) {
      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrintImg = document.createElement("div");
        elementToPrintImg.style.width = "50%";
        elementToPrintImg.style.float = "left";

        var elementToPrintZaglavlje = document.createElement("div");
        elementToPrintZaglavlje.style.width = "50%";
        elementToPrintZaglavlje.style.margin = "10px 0px 0px 0%";
        elementToPrintZaglavlje.style.float = "right";

        var elementToPrint1 = document.createElement("img");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "0px 0px 0px 0%";
        elementToPrint1.src =
          "../assets/wineries/" +
          localStorage.getItem("vinarija") +
          "/logo.png";
        elementToPrintImg.append(elementToPrint1);

        elementToPrint.append(elementToPrintImg);

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        elementToPrint1.innerHTML = object.name;
        elementToPrint1.style.fontSize = "10px";
        elementToPrint1.style.fontWeight = "bold";

        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Telefon: " + object.phone;
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "PIB: " +
          (object.taxNumber !== null ? object.taxNumber : "") +
          " / " +
          "MB: " +
          (object.identityNumber !== null ? object.identityNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 5px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.email + " / " + "www.fruvin.com";
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint.append(elementToPrintZaglavlje);

        var nizRacun = object.bankAccount.split("|");
        var nizBanka = object.bankName.split("|");

        for (var j = 0; j < nizBanka.length; j++) {
          elementToPrint1 = document.createElement("p");
          elementToPrint1.style.margin = "3px 0px 0px 50%";
          // elementToPrint1.style.margin = "5px 0px 0px 10px";
          elementToPrint1.innerHTML = nizRacun[j] + " " + nizBanka[j];
          elementToPrint1.style.fontWeight = "bold";
          elementToPrint1.style.fontSize = "10px";
          elementToPrint.append(elementToPrint1);
        }

        var elementToPrint22222 = document.createElement("p");
        elementToPrint22222.innerHTML = "&nbsp;&nbsp;";
        elementToPrint.append(elementToPrint22222);

        // var elementToPrint2 = document.createElement("p");
        // if (item.number !== undefined)
        //   elementToPrint2.innerHTML = "Izdatnica br. " + item.number;
        // else elementToPrint2.innerHTML = "Izdatnica br. " + item.documentNumber;

        // elementToPrint2.style.position = "relative";
        // elementToPrint2.style.left = "45%";
        // elementToPrint2.style.fontSize = "20px";
        // elementToPrint.append(elementToPrint2);

        // elementToPrint1 = document.createElement("p");
        // elementToPrint1.innerHTML =
        //   "Datum izdavanja :&nbsp;&nbsp;" +
        //   this.formatDate1(item.date.split("T")[0]) +
        //   ".";
        // elementToPrint1.style.margin = "5px 0px 0px 47%";
        // elementToPrint1.style.fontSize = "10px";
        // elementToPrint.append(elementToPrint1);

        var elementToPrint111 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint111.innerHTML = "Izdatnica br. " + item.number;
        else
          elementToPrint111.innerHTML = "Izdatnica br. " + item.documentNumber;

        elementToPrint111.style.margin = "5px 0px 5px 45%";
        elementToPrint111.style.fontSize = "20px";

        var elementToPrint22 = document.createElement("div");
        elementToPrint22.append(elementToPrint111);

        var elementToPrint1111 = document.createElement("p");
        elementToPrint1111.innerHTML =
          "Datum izdavanja :&nbsp;&nbsp;" +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1111.style.margin = "5px 0px 5px 45%";
        // elementToPrint1.style.fontSize = "10px";
        elementToPrint22.append(elementToPrint1111);

        elementToPrint.append(elementToPrint22);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        tbl.style.width = "98%";

        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 5; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv robe");
          //cell
          else if (j === 2) text = document.createTextNode("JM");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("Svrha izdavanja");
          //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "40%";
          else if (j === 2) th.style.width = "10%";
          else if (j === 3) th.style.width = "15%";
          else if (j === 4) th.style.width = "40%";

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 5; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              if (item.warehouseInputOutputItems[i].bottleVolume !== null)
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].wineName +
                    " - " +
                    item.warehouseInputOutputItems[i].wineYear +
                    ", " +
                    item.warehouseInputOutputItems[i].bottleVolume +
                    "l"
                );
              else
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].materialName
                );
            }
            //cell
            else if (j === 2) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 4)
              cellText = document.createTextNode(
                item.typeForOperation !== null
                  ? prevediTipoveIzdavanja(item.typeForOperation)
                  : "-"
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

        elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "15px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "Napomena: " + (item.description === null ? "" : item.description);
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint.append(elementToPrint1);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 3; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "35%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "20%";
            cellText = document.createTextNode("");
          } else {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        let _this = this;

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },

    stampaj_mmi(item, item_out, object) {
      let _this = this;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.name;
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.city;
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "PIB: " + (object.taxNumber !== null ? object.taxNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "MB: " +
          (object.identityNumber !== null ? object.identityNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        var elementToPrint2 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint2.innerHTML =
            "Međumagacinski prenos br. " + item.number;
        else
          elementToPrint2.innerHTML =
            "Međumagacinski prenos br. " + item.documentNumber;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.left = "25%";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Datum prenosa :&nbsp;&nbsp;" +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Izlazni magacin: " + item.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "Magacin prijema: " + item_out.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        tbl.style.width = "98%";

        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 5; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv robe");
          //cell
          else if (j === 2) text = document.createTextNode("Lot");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("JM");
          //cell
          //else if (j === 5) text = document.createTextNode("Iznos u din."); //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "40%";
          else if (j === 2) th.style.width = "20%";
          else if (j === 3) th.style.width = "15%";
          else if (j === 4) th.style.width = "20%";

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 5; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].wineName +
                  " " +
                  item.warehouseInputOutputItems[i].wineYear
              );
            }
            //cell
            else if (j === 4) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 2)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].lot
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 3; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "35%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "20%";
            cellText = document.createTextNode("");
          } else {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },

    stampaj_mmi_fruvin(item, item_out, object) {
      let _this = this;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrintImg = document.createElement("div");
        elementToPrintImg.style.width = "50%";
        elementToPrintImg.style.float = "left";

        var elementToPrintZaglavlje = document.createElement("div");
        elementToPrintZaglavlje.style.width = "50%";
        elementToPrintZaglavlje.style.margin = "10px 0px 0px 0%";
        elementToPrintZaglavlje.style.float = "right";

        var elementToPrint1 = document.createElement("img");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "0px 0px 0px 0%";
        elementToPrint1.src =
          "../assets/wineries/" +
          localStorage.getItem("vinarija") +
          "/logo.png";
        elementToPrintImg.append(elementToPrint1);

        elementToPrint.append(elementToPrintImg);

        var elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        elementToPrint1.innerHTML = object.name;
        elementToPrint1.style.fontSize = "10px";
        elementToPrint1.style.fontWeight = "bold";

        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.address;
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Telefon: " + object.phone;
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 0px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "PIB: " +
          (object.taxNumber !== null ? object.taxNumber : "") +
          " / " +
          "MB: " +
          (object.identityNumber !== null ? object.identityNumber : "");
        elementToPrint1.style.fontWeight = "bold";
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "3px 0px 5px 0%";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = object.email + " / " + "www.fruvin.com";
        elementToPrint1.style.fontSize = "10px";
        elementToPrintZaglavlje.append(elementToPrint1);

        elementToPrint.append(elementToPrintZaglavlje);

        var nizRacun = object.bankAccount.split("|");
        var nizBanka = object.bankName.split("|");

        for (var j = 0; j < nizBanka.length; j++) {
          elementToPrint1 = document.createElement("p");
          elementToPrint1.style.margin = "3px 0px 0px 50%";
          // elementToPrint1.style.margin = "5px 0px 0px 10px";
          elementToPrint1.innerHTML = nizRacun[j] + " " + nizBanka[j];
          elementToPrint1.style.fontWeight = "bold";
          elementToPrint1.style.fontSize = "10px";
          elementToPrint.append(elementToPrint1);
        }

        var elementToPrint22222 = document.createElement("p");
        elementToPrint22222.innerHTML = "&nbsp;&nbsp;";
        elementToPrint.append(elementToPrint22222);

        var elementToPrint22 = document.createElement("div");

        var elementToPrint2 = document.createElement("p");
        if (item.number !== undefined)
          elementToPrint2.innerHTML =
            "Međumagacinski prenos br. " + item.number;
        else
          elementToPrint2.innerHTML =
            "Međumagacinski prenos br. " + item.documentNumber;

        // elementToPrint2.style.position = "relative";
        elementToPrint2.style.margin = "5px 0px 0px 10px";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint22.append(elementToPrint2);

        elementToPrint.append(elementToPrint22);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.innerHTML =
          "Datum prenosa :&nbsp;&nbsp;" +
          this.formatDate1(item.date.split("T")[0]) +
          ".";
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML = "Izlazni magacin: " + item.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        elementToPrint1 = document.createElement("p");
        elementToPrint1.style.margin = "5px 0px 0px 10px";
        // elementToPrint1.style.margin = "5px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "Magacin prijema: " + item_out.warehouse.name;
        // elementToPrint1.style.fontWeight = "bold";
        elementToPrint.append(elementToPrint1);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        tbl.style.width = "98%";

        var tr = document.createElement("tr"); // Header row
        for (var j = 0; j < 5; j++) {
          var th = document.createElement("th"); //column
          var text = "";

          if (j === 0) text = document.createTextNode("Rb");
          //cell
          else if (j === 1) text = document.createTextNode("Naziv robe");
          //cell
          else if (j === 2) text = document.createTextNode("Lot");
          //cell
          else if (j === 3) text = document.createTextNode("Količina");
          //cell
          else if (j === 4) text = document.createTextNode("JM");
          //cell
          //else if (j === 5) text = document.createTextNode("Iznos u din."); //cell

          th.appendChild(text);

          if (j === 0) th.style.width = "5%";
          else if (j === 1) th.style.width = "40%";
          else if (j === 2) th.style.width = "20%";
          else if (j === 3) th.style.width = "15%";
          else if (j === 4) th.style.width = "20%";

          tr.appendChild(th);
        }

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        for (var i = 0; i < item.warehouseInputOutputItems.length; i++) {
          var row = document.createElement("tr");

          for (var j = 0; j < 5; j++) {
            var cell = document.createElement("td");

            var cellText = "";

            if (j === 0) cellText = document.createTextNode(i + 1);
            //cell
            else if (j === 1) {
              if (
                item.warehouseInputOutputItems[i].bottleVolumeInLitres !== null
              )
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].wineName +
                    " - " +
                    item.warehouseInputOutputItems[i].wineYear +
                    ", " +
                    item.warehouseInputOutputItems[i].bottleVolumeInLitres +
                    "l"
                );
              else
                cellText = document.createTextNode(
                  item.warehouseInputOutputItems[i].materialName
                );
            }
            //cell
            else if (j === 4) cellText = document.createTextNode("kom.");
            //cell
            else if (j === 3)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].quantity
              );
            //cell
            else if (j === 2)
              cellText = document.createTextNode(
                item.warehouseInputOutputItems[i].lot
              );

            cell.appendChild(cellText);

            if (j === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px;"
              );
            else cell.setAttribute("style", "text-align :center;");

            row.appendChild(cell);
          }

          tblBody.appendChild(row);
        }

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "20px 0px 0px 2%";

        elementToPrint.appendChild(tbl);

        elementToPrint1 = document.createElement("p");
        //format za margin ide "top, right, bottom, left"
        elementToPrint1.style.margin = "15px 0px 0px 10px";
        elementToPrint1.innerHTML =
          "Napomena: " +
          (item.description === null || item.description === undefined
            ? ""
            : item.description);
        // elementToPrint1.style.fontSize = '20px';
        elementToPrint.append(elementToPrint1);

        var tbl = document.createElement("table");
        tbl.style.width = "100%";

        var tblBody = document.createElement("tbody");

        var row = document.createElement("tr");

        for (var j = 0; j < 3; j++) {
          var cell = document.createElement("td");
          var cellText = "";

          var x = document.createElement("I");

          if (j === 0) {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "35%";

            cellText = document.createTextNode("Izdao");
          } else if (j === 1) {
            cell.style.width = "20%";
            cellText = document.createTextNode("");
          } else {
            cell.setAttribute("style", "border-top: 1px solid;");
            cell.style.width = "25%";
            cellText = document.createTextNode("Primio");
          }

          x.appendChild(cellText);
          cell.appendChild(x);

          row.appendChild(cell);
        }

        tblBody.appendChild(row);

        tbl.style.margin = "50px 0px 0px 10px";
        // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampaj_dnevnik() {
      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint2.style.margin = "0px";
        elementToPrint.append(elementToPrint2);

        var elementToPrint3 = document.createElement("p");

        elementToPrint.append(elementToPrint3);

        if (_this.datumOdFiter !== "" || _this.datumDoFiter !== "") {
          let pomocni_tekst = "";

          if (_this.datumOdFiter !== "" || _this.datumDoFiter !== "") {
            if (_this.datumOdFiter !== "") {
              pomocni_tekst =
                pomocni_tekst +
                "Period: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

              if (_this.datumDoFiter !== "")
                pomocni_tekst =
                  pomocni_tekst +
                  " - " +
                  _this.formatDate1(_this.datumDoFiter) +
                  ".";
            } else
              pomocni_tekst =
                pomocni_tekst +
                "Za period do: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

            pomocni_tekst = pomocni_tekst + "<br>";
          }

          var elementToPrint1 = document.createElement("p");

          elementToPrint1.innerHTML = pomocni_tekst + " <br>";

          elementToPrint1.style.margin = "5px 0px 0px 0px";
          elementToPrint1.style.fontSize = "14px";
          elementToPrint.append(elementToPrint1);
        }

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if ((val === null || val === 0 || val === "") && !isLastElement)
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (_this.json_fields_type[pomJ] === "Number") {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        // var tbl = document.createElement("table");
        // var tblBody = document.createElement("tbody");

        // tbl.style.margin = "20px 0px 0px 82%";
        // tbl.style.width = "18%";
        // // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    changeSort(column) {
      if (typeof column !== "undefined")
        if (column !== "funkcije")
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
    },
    changeSortKartica(column) {
      if (typeof column !== "undefined")
        if (column !== "funkcije")
          if (this.paginationKartica.sortBy === column) {
            this.paginationKartica.descending =
              !this.paginationKartica.descending;
          } else {
            this.paginationKartica.sortBy = column;
            this.paginationKartica.descending = false;
          }
    },
    sumValue(item, key) {
      let suma = item.lots.reduce((a, b) => a + (b[key] || 0), 0);

      suma = Math.round(suma * 100) / 100 + " RSD";

      return suma;
    },
    getAllSellers() {
      let url = "";

      if (this.type !== "bottled_wine") url = "/company/all/sellers";
      else url = "/company/all/buyers";

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          console.log(response.data);

          this.company_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      // // console.log(response.data);

                      this.company_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllBuyers() {
      let url = "";

      url = "/company/all/buyers";

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.company_to_items_dobavljaci = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      // // console.log(response.data);

                      this.company_to_items_dobavljaci = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/" +
            this.id +
            "/chart",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.dataLok = response.data;

          this.ucitajGrafik();

          this.doSomething();
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/" +
                        this.id +
                        "/chart",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.dataLok = response.data;

                      this.ucitajGrafik();

                      this.doSomething();
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    processData: function (data) {
      var treeData = [];

      var smallBrands = { name: "Other", children: [] };
      // var smallBrands = {[]};

      for (var brand in data) {
        var brandData = { name: brand, children: [] };
        var brandTotal = 0;
        for (var model in data[brand]) {
          brandTotal += data[brand][model];
        }

        for (var model in data[brand]) {
          // do not add very small
          if (data[brand][model] > 0) {
            brandData.children.push({ name: model, count: data[brand][model] });
          }
        }

        treeData.push(brandData);
      }

      return treeData;
    },
    prevediDokumenata(stringLok) {
      let pomStr = "";

      if (stringLok == "INPUT") pomStr = "Prijem";
      else if (stringLok == "CHANGE_WAREHOUSE_OUTPUT")
        pomStr = "Međumagacinski izlaz";
      else if (stringLok == "CHANGE_WAREHOUSE_INPUT")
        pomStr = "Međumagacinski prijem";
      else if (stringLok == "TURN_BACK") pomStr = "Povraćaj";
      else if (stringLok == "OUTPUT") pomStr = "Izdavanje";
      else if (stringLok == "WRITE_OFF") pomStr = "Otpis";
      else if (stringLok == "SELLING") pomStr = "Prodaja";
      else if (stringLok == "LAUNCH") pomStr = "Lansiranje";
      else if (stringLok == "INVENTORY") pomStr = "Popis";
      else if (stringLok === "STARTING_STATE") pomStr = "Početno stanje";
      else pomStr = stringLok;

      return pomStr;
    },
    prevediTipoveDokumenata(stringLok) {
      let pomStr = "";

      if (stringLok == "CASH") pomStr = "Gotovina";
      else if (stringLok == "CARD") pomStr = "Kartica";
      else if (stringLok == "CHEQUE") pomStr = "Ček";
      else if (stringLok == "ACCOUNT") pomStr = "Virman";
      else if (stringLok == "COMPENSATION") pomStr = "Kompenzacija";
      else if (stringLok == "GIFT") pomStr = "Poklon";
      else if (stringLok == "TASTING") pomStr = "Degustacija";
      else if (stringLok == "REPRESENTATION") pomStr = "Reprezentacija";
      else if (stringLok == "FAIR") pomStr = "Sajam";
      else pomStr = "Ostalo";

      return pomStr;
    },
    changeBuyer(a) {
      this.getAllRazduzenja(a.id);
    },
    doSomethingRazduzenja() {
      if (this.selectedTabRazduzenja === 0) {
        this.razduzenja_company_to_select = undefined;
        this.getAllRazduzenja(0);
      } else {
        // this.items_states = [];
        // this.ukupnoRedova = 0;

        this.getAllSellers();

        if (this.razduzenja_company_to_select !== undefined)
          this.getAllRazduzenja(this.razduzenja_company_to_select.id);
        else {
          this.items_states = [];
          this.ukupnoRedova = 0;
        }
      }
    },
    doSomething() {
      this.search = "";

      this.izabranaStranica = 0;

      this.paginationKartica.rowsPerPage = 25;
      this.redovaPoStrani = 25;

      this.ukupnoRedova = 0;

      this.paginationKartica.page = 1;

      this.items_states = [];
      this.items_states_pom = [];

      let n = this.selectedTab + 1;

      if (this.selectedTab === 0) {
        if (this.type !== "bottled_wine")
          this.headers_states = [
            // { text: "" },
            { text: "" },
            { text: "Naziv", value: "name", align: "center", sortable: true },
            { text: "Količina", align: "center", sortable: false },
            { text: "Poslednja ulazna cena", align: "center" },
            {
              text: "Vrednost",
              align: "center",
              value: "value",
              sortable: true,
            }, //,
            // { text: "Funkcije", value: "name", align: "center" }
          ];
        else
          this.headers_states = [
            // { text: "" },
            { text: "" },
            { text: "Naziv", value: "name", align: "right", sortable: true },
            { text: "Boca", align: "center" },
            {
              text: "Stanje boca",
              align: "center",
              value: "quantityState",
              sortable: true,
            },
            {
              text: "Količina",
              align: "center",
              value: "quantityStateInLitres",
              sortable: true,
            },
          ];
      } else if (this.selectedTab === 2) {
        // this.document_type_to_select = [];
        this.getAllWarehouses();

        this.headers_states = [
          { text: "" },
          {
            text: "Dokument",
            value: "number",
            align: "center",
            sortable: true,
          },
          { text: "Datum", value: "date", align: "center", sortable: true },
          { text: "Izdao", value: "give", align: "center", sortable: false },
          {
            text: "Primio",
            value: "receive",
            align: "center",
            sortable: false,
          },
          {
            text: "Dobavljač/Kupac",
            value: "company",
            align: "center",
            sortable: false,
          },
          { text: "Funkcije", value: "name", align: "center", sortable: false },
        ];
      } else if (this.selectedTab === 1) {
        if (this.type !== "bottled_wine") {
          this.getAllArticles();
          this.getAllArticlesKartica();

          this.headers_states = [
            // { text: "" },
            { text: "" },
            { text: "Datum", value: "date", align: "center", sortable: true },
            {
              text: "Dokument",
              value: "documentNumber",
              align: "center",
              sortable: true,
            },
            { text: "Lot", value: "lot", align: "center", sortable: false },
            {
              text: "Proizvedeno",
              value: "productionDate",
              align: "center",
              sortable: false,
            },
            {
              text: "Važi do",
              value: "validTo",
              align: "center",
              sortable: false,
            },
            {
              text: "Ulaz",
              value: "quantity",
              align: "center",
              sortable: false,
            },
            {
              text: "Izlaz",
              value: "quantity",
              align: "center",
              sortable: false,
            },
            {
              text: "Količina",
              value: "quantityState",
              align: "center",
              sortable: false,
            },
            {
              text: "Funkcije",
              value: "name",
              align: "center",
              sortable: false,
            },
          ];
        } else {
          this.getAllWineKartica();

          this.headers_states = [
            // { text: "" },
            { text: "" },
            { text: "Datum", value: "date", align: "center", sortable: true },
            {
              text: "Dokument",
              value: "documentNumber",
              align: "center",
              sortable: true,
            },
            // { text: "Tank", value: "tank", align: "center", sortable: false },
            // { text: "Tip", value: "type", align: "center", sortable: true },
            { text: "Lot", value: "lot", align: "center", sortable: false },
            {
              text: "Magacioner",
              value: "bottlingDate",
              align: "center",
              sortable: false,
            },
            {
              text: "Ulaz",
              value: "quantity",
              align: "center",
              sortable: false,
            },
            {
              text: "Izlaz",
              value: "quantity",
              align: "center",
              sortable: false,
            },
            {
              text: "Stanje boca",
              value: "quantityState",
              align: "center",
              sortable: false,
            },
            {
              text: "Funkcije",
              value: "name",
              align: "center",
              sortable: false,
            },
          ];
        }
      } else if (this.selectedTab === 3)
        this.headers_states = [
          { text: "" },
          {
            text: "Dokument",
            value: "number",
            align: "center",
            sortable: true,
          },
          { text: "Datum", value: "date", align: "center", sortable: true },
          { text: "Izdao", value: "give", align: "center", sortable: true },
          { text: "Primio", value: "receive", align: "center", sortable: true },
          { text: "Funkcije", value: "name", align: "center", sortable: false },
        ];
      else if (this.selectedTab === 4) {
        if (this.type === "bottled_wine") this.getAllWine();
        else this.getAllArticles();

        this.getAllSellers();
        this.getAllBuyers();
        this.getPaymentTypes();

        // this.document_type_to_select = [];
        this.getAllWarehouses();
        this.getOutputTypes();

        this.paginationKartica.sortBy = "article";

        if (this.type !== "bottled_wine")
          this.headers_states = [
            // { text: "" },
            { text: "" },
            {
              text: "Naziv",
              value: "article",
              align: "center",
              sortable: true,
            },
            {
              text: "Dobavljač",
              value: "company",
              align: "center",
              sortable: true,
            },
            {
              text: "Dokument",
              value: "document",
              align: "center",
              sortable: true,
            },
            {
              text: "Tip",
              value: "typeForOperation",
              align: "center",
              sortable: true,
            },
            {
              text: "Količina",
              value: "quantity",
              align: "center",
              sortable: false,
            },
            {
              text: "Vrednost",
              value: "value",
              align: "right",
              sortable: false,
            },
          ];
        else
          this.headers_states = [
            { text: "" },
            {
              text: "Vino",
              value: "article",
              align: "center",
              sortable: true,
            },
            {
              text: "Kupac",
              value: "company",
              align: "center",
              sortable: true,
            },
            {
              text: "Dokument",
              value: "document",
              align: "center",
              sortable: true,
            },
            {
              text: "Tip",
              value: "typeForOperation",
              align: "center",
              sortable: true,
            },
            {
              text: "Količina",
              value: "quantity",
              align: "center",
              sortable: false,
            },
            {
              text: "Vrednost",
              value: "value",
              align: "right",
              sortable: false,
            },
          ];
      } else if (this.selectedTab === 5) {
        this.selectedTabRazduzenja = 0;

        this.headers_states = [
          { text: "" },
          {
            text: "Datum razduženja",
            value: "dateOfDischarge",
            align: "center",
            sortable: true,
          },
          {
            text: "Datum uplate",
            value: "date",
            align: "center",
            sortable: true,
          },
          {
            text: "Uplatio",
            value: "employeePaid.name",
            align: "center",
            sortable: true,
          },
          {
            text: "Prethodni dug",
            value: "previouseDebt",
            align: "center",
            sortable: true,
          },
          {
            text: "Prodaja",
            value: "sellingValue",
            align: "center",
            sortable: true,
          },
          {
            text: "Zaduženje",
            value: "sumForPaying",
            align: "center",
            sortable: true,
          },
          {
            text: "Uplaćeno",
            value: "value",
            align: "center",
            sortable: true,
          },
          { text: "Funkcije", value: "name", align: "center", sortable: false },
        ];
      }

      if (n === 1) this.getAllState();
      else if (n === 2) {
        this.getAllKartice();
      } else if (n === 3) this.getAllPromene();
      else if (n === 4) this.getAllIzvrsenja();
      else if (n === 6) this.getAllRazduzenja(0);
    },
    prijemDokumenta(id) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/execute/" +
            id,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokument je uspešno izvršen.");
          this.getAllSifarnik();
          this.dialogSave = false;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/execute/" +
                        id,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // // console.log(response);
                      alert("Dokument je uspešno izvršen.");
                      this.getAllSifarnik();
                      this.dialogSave = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit_save() {
      if (this.valueMMP && !this.valueMMI)
        alert("Nije moguće izvršiti međumagacinski prijem bez izlaza.");
      else if (this.valueMMP && this.valueMMI) {
        this.prijemObaDokumenta(this.MMPID, this.MMIID);
      } else if (this.valueMMI) {
        this.prijemDokumenta(this.MMIID);
      }
    },
    submit_save_otkazi() {
      if (this.valueMMI && !this.valueMMP)
        alert("Nije moguće otkazati međumagacinski izlaz bez prijema.");
      else if (this.valueMMP && this.valueMMI) {
        this.otkazivanjeObaDokumenta(this.MMPID, this.MMIID);
      } else if (this.valueMMP) {
        this.otkazivanjeDokumenta(this.MMPID);
      }
    },

    closeModalSave() {
      this.dialogSave = false;
    },

    closeModalSaveOtkazi() {
      this.dialogSaveOtkazi = false;
    },
    prijemObaDokumenta(idMMP, idMMI) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/execute/" +
            idMMI +
            "/" +
            idMMP,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokumenti su uspešno izvršeni.");
          this.getAllIzvrsenja();
          this.dialogSave = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/execute/" +
                        idMMI +
                        "/" +
                        idMMP,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Dokumenti su uspešno izvršeni.");
                      this.getAllIzvrsenja();
                      this.dialogSave = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    otkazivanjeObaDokumenta(idMMP, idMMI) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/cancel/" +
            idMMI +
            "/" +
            idMMP,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokumenti su uspešno otkazani.");
          this.getAllSifarnik();
          this.dialogSaveOtkazi = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/cancel/" +
                        idMMI +
                        "/" +
                        idMMP,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Dokumenti su uspešno otkazani.");
                      this.getAllSifarnik();
                      this.dialogSaveOtkazi = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    otkazivanjeDokumenta(id) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/cancel/" +
            id,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // // console.log(response);
          alert("Dokument je uspešno otkazan.");
          this.getAllSifarnik();
          this.dialogSaveOtkazi = false;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/cancel/" +
                        id,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // // console.log(response);
                      alert("Dokument je uspešno otkazan.");
                      this.getAllSifarnik();
                      this.dialogSaveOtkazi = false;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    brisanjeDokumenta(id, pomBroj) {
      let url = "/warehouse_input_output/delete/" + id;

      if (pomBroj !== 0 && pomBroj !== null)
        url =
          "/warehouse_input_output/change_warehouse/delete/" +
          id +
          "/" +
          pomBroj;

      this.$http
        .delete(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // // console.log(response);
          alert("Dokument je uspešno obrisan.");
          this.getAllSifarnik();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation + this.globalPort + url,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // // console.log(response);
                      alert("Dokument je uspešno obrisan.");
                      this.getAllSifarnik();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    showFields(a) {
      let sellingIndex = a.findIndex((element) => element === "SELLING");

      if (sellingIndex >= 0) this.showVrstePlacanja = true;
      else {
        this.showVrstePlacanja = false;
        this.placanja_select = undefined;
      }

      let outputIndex = a.findIndex((element) => element === "OUTPUT");

      if (outputIndex >= 0) this.showSvrhaIzdavanja = true;
      else {
        this.showSvrhaIzdavanja = false;
        this.company_to_select = undefined;

        this.output_type_to_select = undefined;
      }

      let inputIndex = a.findIndex((element) => element === "INPUT");

      if (inputIndex >= 0) this.showDobavljace = true;
      else {
        this.showDobavljace = false;
        this.company_to_select_dobavljaci = undefined;

        this.output_type_to_select = undefined;
      }
    },
    getAllState() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/state/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let _this = this;
          this.totalTab0 = 0;
          this.totalBoca = 0;

          this.items_states = JSON.parse(JSON.stringify(response.data));

          if (this.type === "bottled_wine") {
            this.totalTab0 = 0;
            this.totalBoca = 0;

            response.data.forEach(function (entry) {
              _this.totalTab0 = _this.totalTab0 + entry.quantityState;
              _this.totalBoca = _this.totalBoca + entry.quantityStateInLitres;
            });
          }

          this.getAllStateTotal();
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/state/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let _this = this;
                      this.totalTab0 = 0;
                      this.totalBoca = 0;

                      this.items_states = JSON.parse(
                        JSON.stringify(response.data)
                      );

                      if (this.type === "bottled_wine") {
                        this.totalTab0 = 0;
                        this.totalBoca = 0;

                        response.data.forEach(function (entry) {
                          _this.totalTab0 =
                            _this.totalTab0 + entry.quantityState;
                          _this.totalBoca =
                            _this.totalBoca + entry.quantityStateInLitres;
                        });
                      }

                      this.getAllStateTotal();
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllStateTotal() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/state/total_material/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.total = response.data.totalVolume;

          // this.items_states = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/state/total_material/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.total = response.data.totalVolume;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllIzvrsenja() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/unexecuted/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          // this.items_states = JSON.parse(JSON.stringify(response.data));

          this.items_states = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/unexecuted/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_states = response.data;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllRazduzenja(companyId) {
      let pageLoc = "page=" + this.izabranaStranica;

      let offsetLoc = "&offset=" + this.paginationKartica.rowsPerPage;

      let sortiranje = "";
      // if (
      //   this.paginationKartica.sortBy === "date" ||
      //   this.paginationKartica.sortBy === "number"
      // ) {
      //   let orderovanje = "";
      //   if (this.paginationKartica.descending) orderovanje = "desc&";
      //   else orderovanje = "asc&";

      //   sortiranje =
      //     "sort=" +
      //     this.paginationKartica.sortBy.replace("documentNumber", "number") +
      //     "&order=" +
      //     orderovanje;
      // }

      let strCompanyId = "";
      if (companyId !== 0) {
        strCompanyId = "&companyId=" + companyId;
      }

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_payment_flow/" +
            this.id +
            "/cash_flow?" +
            pageLoc +
            offsetLoc +
            sortiranje +
            strCompanyId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          // this.items_states = JSON.parse(JSON.stringify(response.data));

          if (companyId === -111) {
            this.items_states = [];

            this.ukupnoRedova = 0;
          } else {
            this.items_states = response.data.content;

            this.ukupnoRedova = response.data.totalElements;
          }
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_payment_flow/" +
                        this.id +
                        "/cash_flow?" +
                        pageLoc +
                        offsetLoc +
                        sortiranje +
                        strCompanyId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_states = response.data.content;
                      this.items_states_pom = response.data.content;

                      this.ukupnoRedova = response.data.totalElements;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllPromene() {
      this.naziv_fajla = "stanje_magacina.xls";
      this.naslov = "Dnevnik promena za magacin " + this.name;
      // this.podnaslov = getDateTimeNaslov();

      if (this.type !== "bottled_wine")
        this.json_fields = {
          "Redni broj": "String",
          "Dokument/Repromaterijal": "String",
          "Datum/Lot": "String",
          "Izdao/Rok upotrebe": "String",
          "Primio/Količina": "String",
          "Dobavljač/Kupac": "String",
          Opis: "String",
        };
      else
        this.json_fields = {
          "Redni broj": "String",
          "Dokument/Vino": "String",
          "Datum/Lot": "String",
          "Izdao/Zapremina": "String",
          "Primio/Količina": "String",
          "Dobavljač/Kupac": "String",
          Opis: "String",
        };

      this.json_fields_type = [
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
      ];

      let strDate = "";
      if (this.date !== null) {
        strDate = "dateFrom=" + this.date + "T00:00";
        this.datumOdFiter = this.date;
      }

      let strDateKupovine = "";
      if (this.dateKupovine !== null) {
        this.datumDoFiter = this.dateKupovine;

        if (this.date === null)
          strDateKupovine = "dateTo=" + this.dateKupovine + "T23:59";
        else strDateKupovine = "&dateTo=" + this.dateKupovine + "T23:59";
      }

      var complexObjectDocumentType = "";

      if (
        typeof this.document_type_to_select !== "undefined" &&
        this.document_type_to_select !== null
      ) {
        this.document_type_to_select.forEach(function (entry) {
          complexObjectDocumentType =
            complexObjectDocumentType + "&type=" + entry;
        });
      }

      // if (complexObjectDocumentType !== "")
      //   complexObjectDocumentType = complexObjectDocumentType.substring(1);

      let pageLoc = "&page=" + this.izabranaStranica;

      let offsetLoc = "&offset=" + this.paginationKartica.rowsPerPage;

      let sortiranje = "";
      if (
        this.paginationKartica.sortBy === "date" ||
        this.paginationKartica.sortBy === "number"
      ) {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc&";
        else orderovanje = "asc&";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/diary/" +
            this.id +
            "?" +
            sortiranje +
            strDate +
            strDateKupovine +
            complexObjectDocumentType +
            pageLoc +
            offsetLoc,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let redni_broj = 0;

          if (this.search !== "") {
            let pomSearch = this.search;

            this.search = "";
            this.search = pomSearch;
          }

          this.items_states = response.data.content;
          this.items_states_pom = response.data.content;

          this.ukupnoRedova = response.data.totalElements;
          let _this = this;
          this.json_data = [];

          response.data.content.forEach(function (entry) {
            redni_broj = redni_broj + 1;

            let objekat = {
              "Redni broj": redni_broj,
              Dokument: entry.number,
              Datum: _this.formatDateTime(entry.date),
              Izdao:
                entry.give !== null
                  ? entry.give.firstName + " " + entry.give.lastName
                  : "-",
              Primio:
                entry.receive !== null
                  ? entry.receive.firstName + " " + entry.receive.lastName
                  : "-",
              "Dobavljač/Kupac":
                entry.company !== null ? entry.company.name : "",
              Opis: entry.description,
            };

            _this.json_data.push(objekat);

            entry.warehouseInputOutputItems.forEach(function (entry1) {
              let objekat_pom = {
                "Redni broj": " ",
                Dokument:
                  entry1.wineName !== null
                    ? entry1.wineName + " " + entry1.wineYear
                    : entry1.materialName,
                Datum: entry1.lot !== null ? entry1.lot : "-",
                Izdao:
                  entry1.wineName !== null
                    ? entry1.bottleVolume + "l"
                    : entry1.validTo !== null
                    ? _this.formatDateTime1(entry1.validTo)
                    : "-",
                Primio:
                  entry1.wineName !== null
                    ? entry1.quantity
                    : entry1.quantity +
                      " " +
                      entry1.quantityUnitOfMeasure.mark.replace("psc", "kom"),
                "Dobavljač/Kupac": "",
                Opis: "",
              };

              _this.json_data.push(objekat_pom);
            });
          });
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/diary/" +
                        this.id +
                        "?" +
                        strDate +
                        strDateKupovine +
                        pageLoc +
                        offsetLoc,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let redni_broj = 0;

                      if (this.search !== "") {
                        let pomSearch = this.search;

                        this.search = "";
                        this.search = pomSearch;
                      }

                      this.items_states = response.data.content;
                      this.items_states_pom = response.data.content;

                      this.ukupnoRedova = response.data.totalElements;
                      let _this = this;
                      this.json_data = [];

                      response.data.content.forEach(function (entry) {
                        redni_broj = redni_broj + 1;

                        let objekat = {
                          "Redni broj": redni_broj,
                          Dokument: entry.number,
                          Datum: _this.formatDateTime(entry.date),
                          Izdao:
                            entry.give !== null
                              ? entry.give.firstName + " " + entry.give.lastName
                              : "-",
                          Primio:
                            entry.receive !== null
                              ? entry.receive.firstName +
                                " " +
                                entry.receive.lastName
                              : "-",
                          "Dobavljač/Kupac":
                            entry.company !== null ? entry.company.name : "",
                          Opis: entry.description,
                        };

                        _this.json_data.push(objekat);

                        entry.warehouseInputOutputItems.forEach(function (
                          entry1
                        ) {
                          let objekat_pom = {
                            "Redni broj": " ",
                            Dokument:
                              entry1.wineName !== null
                                ? entry1.wineName + " " + entry1.wineYear
                                : entry1.materialName,
                            Datum: entry1.lot !== null ? entry1.lot : "-",
                            Izdao:
                              entry1.wineName !== null
                                ? entry1.bottleVolume + "l"
                                : entry1.validTo !== null
                                ? _this.formatDateTime1(entry1.validTo)
                                : "-",
                            Primio:
                              entry1.wineName !== null
                                ? entry1.quantity
                                : entry1.quantity +
                                  " " +
                                  entry1.quantityUnitOfMeasure.mark.replace(
                                    "psc",
                                    "kom"
                                  ),
                            "Dobavljač/Kupac": "",
                            Opis: "",
                          };

                          _this.json_data.push(objekat_pom);
                        });
                      });
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllKartice() {
      if (this.article_to_select === null) this.items_states = [];
      else {
        let strDate = "";
        if (this.dateOd !== null)
          strDate = "dateFrom=" + this.dateOd + "T00:00&";

        let strDateDo = "";
        if (this.dateDo !== null)
          strDateDo = "dateTo=" + this.dateDo + "T23:59&";

        // if (this.type === "bottled_wine")
        //   if (this.bottle_to_select === null) {
        //     this.items_states = [];

        //     return;
        //   } else {
        //     var pom_bottle_to_select;

        //     if (
        //       typeof this.bottle_to_select !== "undefined" &&
        //       this.bottle_to_select !== ""
        //     ) {
        //       if (typeof this.bottle_to_select.id === "undefined")
        //         pom_bottle_to_select = this.bottle_to_select;
        //       else pom_bottle_to_select = this.bottle_to_select.id;
        //     }
        //   }

        var pom_article_to_select;

        if (
          typeof this.article_to_select !== "undefined" &&
          this.article_to_select !== ""
        ) {
          if (typeof this.article_to_select.id === "undefined")
            pom_article_to_select = this.article_to_select;
          else pom_article_to_select = this.article_to_select.id;
        }

        let sortiranje = "";
        if (
          this.paginationKartica.sortBy === "date" ||
          this.paginationKartica.sortBy === "documentNumber"
        ) {
          let orderovanje = "";
          if (this.paginationKartica.descending) orderovanje = "desc&";
          else orderovanje = "asc&";

          sortiranje =
            "sort=" +
            this.paginationKartica.sortBy.replace("documentNumber", "number") +
            "&order=" +
            orderovanje;
        }

        let urlLoc =
          "material_changes/" +
          this.id +
          "?materialId=" +
          pom_article_to_select +
          "&" +
          sortiranje;

        if (this.type === "bottled_wine")
          urlLoc =
            "wine_changes/" +
            this.id +
            "?wineId=" +
            pom_article_to_select +
            "&" +
            sortiranje;

        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/warehouse_input_output/" +
              urlLoc +
              strDate +
              strDateDo +
              "page=" +
              this.izabranaStranica +
              "&offset=" +
              this.paginationKartica.rowsPerPage,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.items_states = response.data.content;

            this.ukupnoRedova = response.data.totalElements;
          })
          .catch((e) => {
            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/warehouse_input_output/" +
                          urlLoc +
                          "&dateFrom=" +
                          this.dateOd +
                          "T00:00&dateTo=" +
                          this.dateDo +
                          "T23:59&page=0&offset=25",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.items_states = response.data.content;
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    getAllAnalitika() {
      // if (this.article_to_select_analitika === null) this.items_states = [];
      // else {
      let strDate = "";
      if (this.dateOdAnalitika !== null)
        strDate = "dateFrom=" + this.dateOdAnalitika + "T00:00&";

      let strDateDo = "";
      if (this.dateDoAnalitika !== null)
        strDateDo = "dateTo=" + this.dateDoAnalitika + "T23:59&";

      // var pom_article_to_select;

      // var complexObjectArticle = "";

      // if (typeof this.article_to_select_analitika !== "undefined") {
      //   this.article_to_select_analitika.forEach(function (entry) {
      //     complexObjectArticle =
      //       complexObjectArticle + "&articleId=" + entry.id;
      //   });
      // }

      var complexObjectArticle = "";

      if (this.article_to_select_analitika.length !== 0) {
        this.article_to_select_analitika.forEach(function (entry) {
          complexObjectArticle =
            complexObjectArticle + "&articleId=" + entry.id;
        });
      }

      var complexObjectCompany = "";

      if (
        typeof this.company_to_select !== "undefined" &&
        this.company_to_select !== null
      ) {
        this.company_to_select.forEach(function (entry) {
          complexObjectCompany = complexObjectCompany + "&companyId=" + entry;
        });
      }

      if (
        typeof this.company_to_select_dobavljaci !== "undefined" &&
        this.company_to_select_dobavljaci !== null
      ) {
        this.company_to_select_dobavljaci.forEach(function (entry) {
          complexObjectCompany = complexObjectCompany + "&companyId=" + entry;
        });
      }

      var complexObjectDocumentType = "";

      if (
        typeof this.document_type_to_select !== "undefined" &&
        this.document_type_to_select !== null
      ) {
        this.document_type_to_select.forEach(function (entry) {
          complexObjectDocumentType =
            complexObjectDocumentType + "&document=" + entry;
        });
      }

      var complexObjectPaymentType = "";

      if (
        typeof this.placanja_select !== "undefined" &&
        this.placanja_select !== null
      ) {
        this.placanja_select.forEach(function (entry) {
          complexObjectPaymentType =
            complexObjectPaymentType + "&type=" + entry;
        });
      }

      if (
        typeof this.output_type_to_select !== "undefined" &&
        this.output_type_to_select !== null
      ) {
        this.output_type_to_select.forEach(function (entry) {
          complexObjectPaymentType =
            complexObjectPaymentType + "&type=" + entry;
        });
      }

      let sortiranje = "";
      if (
        this.paginationKartica.sortBy === "article" ||
        this.paginationKartica.sortBy === "company" ||
        this.paginationKartica.sortBy === "document" ||
        this.paginationKartica.sortBy === "typeForOperation"
      ) {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc&";
        else orderovanje = "asc&";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("typeForOperation", "type") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "analitic?warehouseId=" +
        this.id +
        complexObjectArticle +
        complexObjectCompany +
        complexObjectDocumentType +
        complexObjectPaymentType +
        "&" +
        sortiranje;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/" +
            urlLoc +
            strDate +
            strDateDo +
            "page=" +
            this.izabranaStranica +
            "&offset=" +
            this.paginationKartica.rowsPerPage,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items_states = response.data.content;

          this.ukupnoRedova = response.data.totalElements;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/" +
                        urlLoc +
                        "&dateFrom=" +
                        this.dateOd +
                        "T00:00&dateTo=" +
                        this.dateDo +
                        "T23:59&page=0&offset=25",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_states = response.data.content;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
      // }
    },
    getAllArticles() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/materials/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.article_to_items_analitika = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/materials/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.article_to_items_analitika = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllArticlesKartica() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/turn_off_materials/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.article_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/turn_off_materials/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.article_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      this.search = "";

      this.paginationKartica.sortBy = "date";
      this.paginationKartica.descending = true;
      this.paginationKartica.rowsPerPage = 25;
      this.paginationKartica.descending = true;
      this.paginationKartica.page = 1;

      this.getAllPromene();
    },
    submitKartice() {
      if (this.$refs.form.validate()) this.getAllKartice();
    },
    submitRazduzenja() {
      if (this.$refs.form1.validate())
        this.getAllRazduzenja(this.razduzenja_company_to_select.id);
    },
    submitAnalitika() {
      this.getAllAnalitika();
    },
    getAllWine() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/wines/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.article_to_items_analitika = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/wines/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.article_to_items_analitika = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllWineKartica() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/turn_off_wines/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.article_to_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/turn_off_wines/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.article_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllWarehouses() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/document_types/" +
            this.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.document_type_to_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/document_types/" +
                        this.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.document_type_to_items = response.data;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        if (
          (newVal.page !== oldVal.page ||
            newVal.rowsPerPage !== oldVal.rowsPerPage ||
            newVal.sortBy !== oldVal.sortBy ||
            newVal.descending !== oldVal.descending) &&
          newVal.sortBy !== "receive" &&
          newVal.sortBy !== "give" &&
          newVal.sortBy !== "company"
        ) {
          this.izabranaStranica = this.paginationKartica.page - 1;

          if (this.selectedTab === 2) this.getAllPromene();
          else if (this.selectedTab === 4) this.getAllAnalitika();
          else if (this.selectedTab === 5) {
            if (this.razduzenja_company_to_select === undefined)
              this.getAllRazduzenja(0);
            else this.getAllRazduzenja(this.razduzenja_company_to_select.id);
          } else this.getAllKartice();
        }

        let search = this.search.trim().toLowerCase();

        if (this.selectedTab === 2) {
          this.items_states_pom = this.items_states.filter(function (item) {
            let lokDate = item.date.split("T")[0];
            let lokTime = item.date.split("T")[1];

            let month = lokDate.split("-")[1];
            let day = lokDate.split("-")[2];
            const year = lokDate.split("-")[0];

            let HH = lokTime.split(":")[0];
            let mm = lokTime.split(":")[1];

            let datumVreme =
              [day, month, year].join(".") + " " + [HH, mm].join(":");

            if (item.receive !== null && item.give !== null)
              return (
                item.receive.firstName.toLowerCase().indexOf(search) > -1 ||
                item.receive.lastName.toLowerCase().indexOf(search) > -1 ||
                item.give.firstName.toLowerCase().indexOf(search) > -1 ||
                item.give.lastName.toLowerCase().indexOf(search) > -1 ||
                item.number.toLowerCase().indexOf(search) > -1 ||
                datumVreme.toLowerCase().indexOf(search) > -1
              );
            else if (item.give !== null)
              return (
                item.give.firstName.toLowerCase().indexOf(search) > -1 ||
                item.give.lastName.toLowerCase().indexOf(search) > -1 ||
                item.number.toLowerCase().indexOf(search) > -1 ||
                datumVreme.toLowerCase().indexOf(search) > -1
              );
            else if (item.receive !== null)
              return (
                item.receive.firstName.toLowerCase().indexOf(search) > -1 ||
                item.receive.lastName.toLowerCase().indexOf(search) > -1 ||
                item.number.toLowerCase().indexOf(search) > -1 ||
                datumVreme.toLowerCase().indexOf(search) > -1
              );
            else
              return (
                item.number.toLowerCase().indexOf(search) ||
                datumVreme.toLowerCase().indexOf(search) > -1
              );
          });

          this.ukupnoRedova = this.items_states_pom.length;
        }
      },
      deep: true,
    },
    $route() {
      console.log(this.$route.params);
      this.id = this.$route.params.id;
      this.name = this.$route.params.name;
      this.type = this.$route.params.type;

      this.getAllSifarnik();
    },
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    dateKupovine(val) {
      this.dateFormattedKupovine = this.formatDate1(this.dateKupovine);
    },
    dateOd(val) {
      this.dateFormattedOd = this.formatDate1(this.dateOd);
    },
    dateDo(val) {
      this.dateFormattedDo = this.formatDate1(this.dateDo);
    },
    dateOdAnalitika(val) {
      this.dateFormattedOdAnalitika = this.formatDate1(this.dateOdAnalitika);
    },
    dateDoAnalitika(val) {
      this.dateFormattedDoAnalitika = this.formatDate1(this.dateDoAnalitika);
    },
  },
  beforeMount() {
    serverBus.$on("ucitaj_podatke", (edit) => {
      if (edit) {
        this.getAllSifarnik();
      }
    });
  },
  mounted() {
    console.log(this.$route.params);
    this.id = this.$route.params.id;
    this.name = this.$route.params.name;
    this.type = this.$route.params.type;
    this.typeId = this.$route.params.typeId;

    console.log(this.type);

    this.getAllSifarnik();

    let nizVrednosti;

    if (this.type !== "bottled_wine") {
      this.labelKomitenti = "Kupac";

      nizVrednosti = [false, false, false, false, false, true, false, false];
    } else {
      this.labelKomitenti = "Kupac";

      nizVrednosti = [false, false, false, false, false, false, false, false];
    }

    serverBus.$emit("disable_action_warehouse", nizVrednosti);

    // this.getPaymentTypes();
    // this.getAllSellers();
    // this.getAllWarehouses();
  },
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 10%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 90%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}
</style>
